(function componentForm($, Adzuki)
{
	'use strict';

	var form = {
		name: 'EmailBuilder',
	};

	var email_builder_id    = null;
	var email_builder_type  = null;
	var form_id             = 'emailbuilder-';
	var message_editor      = null;
	var editor_type         = 'text_formats';
	var prev_layout_id      = null;
	var cta_character_count = 125;
	var picker_border_color = '#3DAE2B';
	var picker_text_color   = '#636466';
	var layout_confirm_text = 'Please note that by continuing with this action, you\'re changing the layout of the email and you may lose content that\'s already been entered in.<br><br>Do you wish to continue?';

	// event types for the scheduler
	const no_send_option = [
		'client_anniversary',
		'client_birthday',
		'client_referral'
	];

	const full_send_option = {
		client_passport_expiration: {
			day  : 180,
			label: 'before expiration'
		},
		client_tsa_expiration: {
			day  : 180,
			label: 'before expiration'
		},
		client_global_entry_expiration: {
			day  : 180,
			label: 'before expiration'
		},
		client_uk_eta_expiration: {
			day  : 180,
			label: 'before expiration'
		},
		client_allianz_annual_policy_expiration: {
			day  : 180,
			label: 'before expiration'
		},
		cruise_option_expiration: {
			day  : 30,
			label: 'before expiration'
		},
		final_soft_payment: {
			day  : 7,
			label: 'before final payment due'
		},
		cruise_preregistration: {
			day  : 30,
			label: 'before departure'
		},
		cruise_departs: {
			day  : 3,
			label: 'before departure'
		},
		lodging_checkin: {
			day  : 3,
			label: 'before check-in'
		},
		tour_final_soft_payment: {
			day  : 7,
			label: 'before final payment due'
		},
		tour_departs: {
			day  : 3,
			label: 'before departure'
		},
		package_final_soft_payment: {
			day  : 7,
			label: 'before final payment due'
		},
		package_departs: {
			day  : 3,
			label: 'before departure'
		}
	};

	const seven_day_send_option = {
		client_added: {
			day  : 1,
			label: 'being added'
		},
		just_booked: {
			day  : 1,
			label: 'booking date'
		},
		lodging_just_booked: {
			day  : 1,
			label: 'booking date'
		},
		lodging_checkout: {
			day  : 3,
			label: 'check-out date'
		},
		cruise_returns: {
			day  : 3,
			label: 'return'
		},
		tour_just_booked: {
			day  : 1,
			label: 'booking date'
		},
		tour_returns: {
			day  : 3,
			label: 'return'
		},
		package_just_booked: {
			day  : 1,
			label: 'booking date'
		},
		package_returns: {
			day  : 3,
			label: 'return'
		}
	};

	$(document).ready(function onDocumentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var design_mode = $('#' + form_id + 'design_mode').val();

		email_builder_id   = $('#' + form_id + 'id').val();
		email_builder_type = $('#' + form_id + 'email_builder_type').val();
		prev_layout_id     = parseInt($('#' + form_id + 'email_builder_layout_id').val());

		// update the layout of the email builder
		$('#' + form_id + 'email_builder_layout_id').on('change', function onLayoutChange(e)
		{
			var layout_id = parseInt($(this).val());

			// ids are the same, layout was not changed
			if (layout_id === prev_layout_id) {
				return;
			}

			// show confimation only if switching from layout 2 or 3 to another layout
			if (prev_layout_id > 1) {
				Adzuki.CustomConfirm({
					body   : layout_confirm_text,
					confirm: function confirmLayoutChange() {
						_setLayout(layout_id);

						prev_layout_id = layout_id;
					},
					cancel: function cancelLayoutChange() {
						$('#' + form_id + 'email_builder_layout_id').val(prev_layout_id);
					}
				});

				return;
			}

			_setLayout(layout_id);

			prev_layout_id = layout_id;
		});

		// set the template for the email builder
		$('#' + form_id + 'template_id').on('change', function onTemplateChange(e)
		{
			var template_id = $(this).val();

			if (template_id) {
				_setTemplate(parseInt(template_id));
			}
		});

		$(document).on('click', '#previous_attachments .attachment-remove a', function removePreviousAttachment(e) {
			var $container = $('#previous_attachments');

			e.preventDefault();
			$(this).closest('.previous-attachment').remove();

			if ($container.find('.current_attachments .previous-attachment').length === 0) {
				$container.addClass('hidden');
				$('#' + form_id + 'previous_attachments-source').val('');
			}
		});

		// show template name text field
		$('#' + form_id + 'save_as_template').on('change', function onSaveAsTemplateChange(e)
		{
			if ($(this).is(':checked')) {
				$('.save-template').removeClass('hidden');
				return;
			}

			$('.save-template').addClass('hidden');
		});

		// link to reservation
		$('#' + form_id + 'link_to_reservation').on('change', function onLinkToReservationChange(e)
		{
			if ($(this).is(':checked')) {
				$('.reservation-search').removeClass('hidden');
				return;
			}

			$('.reset-reservation-typeahead').trigger('click');
			$('.reservation-search').addClass('hidden');
		});

		// typeahead for reservation search
		Adzuki.Typeahead(
			$('#' + form_id + 'reservation_search'),
			'/Reservations/searchReservations',
			function select(item, $self, typeahead) {
				$self.prop('disabled', true);
				$('#' + form_id + 'reservation_id').val(item.id);
				$('.reset-reservation-typeahead').removeClass('hidden');
			}
		);

		// reset reservation search
		$('.reset-reservation-typeahead').on('click', function onResetReservationTypeaheadClick(e)
		{
			e.preventDefault();

			$('#' + form_id + 'reservation_search').prop('disabled', false);
			$('#' + form_id + 'reservation_search').val('');
			$('#' + form_id + 'reservation_id').val('');
			$('.reset-reservation-typeahead').addClass('hidden');
		});

		// a few things to do specifically for schedules
		if (email_builder_type === 'schedule') {
			const url = Adzuki.base_uri + '/EmailBuilders/getSchedulerDays';

			// get the event type options
			Adzuki.Ajax.get(url).then(function _getSchedulerDays(response) {
				_schedulerEventTypes(response);
			});
		}

		// save and send, reset draft value
		$('.save-send-btn').on('click', function onSaveSendClick(e)
		{
			$('#' + form_id + 'save_draft').val(0);
		});

		// save as draft
		$('.save-as-draft-btn').on('click', function onSaveDraftClick(e)
		{
			$('#' + form_id + 'save_draft').val(1);
		});

		// edit banner image
		$('.eb-update-banner-btn').on('click', function onEditBannerClick(e)
		{
			e.preventDefault();

			$('.eb-banner-image-container').addClass('hidden');
			$('.eb-banner-view .eb-inline-actions').addClass('hidden');
			$('.eb-banner-edit').removeClass('hidden');
		});

		// preview the banner image
		$('.eb-preview-banner-btn').on('click', function onPreviewBannerClick(e)
		{
			var $banner_field     = $('#' + form_id + 'email_builder_banner_id').first();
			var banner_url        = $banner_field.find(':selected').data('url');
			var validation_errors = [];
			var image_height      = 240;

			e.preventDefault();

			$('.eb-banner-view').find('.has-error').removeClass('has-error');

			if (!banner_url) {
				validation_errors.push({
					field: $banner_field,
					error: 'You must select a Banner Image',
				});

				_highlightErrorFields(validation_errors);
				Adzuki.Form.throwSubmissionError(_getValidationErrorMessage(validation_errors));
				return;
			}

			// set banner image source
			$('.eb-banner-image').attr('src', banner_url).on('load', function imageHeight() {
				image_height = $('.eb-banner-image').height();

				// account for padding
				image_height = image_height - 20;

				// set banner edit container height
				$('.eb-banner-edit').height(image_height);

			});

			// show things
			$('.eb-banner-edit').addClass('hidden');
			$('.eb-banner-image-container').removeClass('hidden');
			$('.eb-banner-view .eb-inline-actions').removeClass('hidden');
		});

		// cancel editing the banner image
		$('.eb-cancel-banner-btn').on('click', function onCancelBannerClick(e)
		{
			e.preventDefault();

			$('.eb-banner-edit').addClass('hidden');
			$('.eb-banner-image-container').removeClass('hidden');
			$('.eb-banner-view .eb-inline-actions').removeClass('hidden');
		});

		// click to view the form to upload a custom banner
		$('.eb-upload-custom-banner-btn').on('click', function onUploadCustomBannerClick(e)
		{
			e.preventDefault();

			$('.eb-banner-edit').addClass('hidden');
			$('.eb-banner-upload').removeClass('hidden');
		});

		// submit the form to upload a custom banner
		$('.eb-upload-banner-btn').on('click', function onUploadBannerClick(e)
		{
			var $self                    = $(this);
			var $banner_upload_container = $('.eb-banner-upload');
			var $banner_input            = $('#' + form_id + 'banner_name');
			var media_ids                = $('#' + form_id + 'banner_media_id').val();
			var banner_name              = $banner_input.val();

			var post_data                = {
				banner_name: banner_name,
				media_ids  : media_ids,
			};

			e.preventDefault();

			$banner_upload_container.find('.form-loader').css('visibility', 'visible');
			$banner_upload_container.find('.has-error').removeClass('has-error');
			$self.attr('disabled', true);

			Adzuki.Ajax.post('/EmailBuilders/uploadCustomContent/banner', post_data)
			.then(function uploadCustomContent(response) {

				$banner_upload_container.find('.form-loader').css('visibility', 'hidden');
				$self.attr('disabled', false);

				// there was a problem uploading the banner
				if (response.error) {
					_highlightErrorFields(response.error);
					Adzuki.Form.throwSubmissionError(_getValidationErrorMessage(response.error));
					return;
				}

				// custom banner uploaded, clear fields for next submission
				$banner_input.val('');
				$('#' + form_id + 'banner_media_id').val(null);

				// update select input options and select the uploaded banner
				_reloadBannerOptions(response.banner_id);

				// display the new banner
				$('.eb-banner-upload').addClass('hidden');
				$('.eb-banner-image-container').removeClass('hidden');
				$('.eb-banner-view .eb-inline-actions').removeClass('hidden');
			});
		});

		// cancel the upload of a custom banner
		$('.eb-cancel-banner-upload-btn').on('click', function onCancelBannerUploadClick(e)
		{
			e.preventDefault();

			$('.eb-banner-upload').addClass('hidden');
			$('.eb-banner-edit').removeClass('hidden');
		});

		// Initialize TinyMCE for email message
		Adzuki.Editor('#' + form_id + 'message', {
			init_instance_callback: function onEditorInit(editor) {
				message_editor = editor;
			}
		});

		// edit email message
		$('.eb-update-message-btn').on('click', function onUpdateMessageClick(e) {
			e.preventDefault();

			$('.eb-message-preview').addClass('hidden');
			$('.eb-message-edit').removeClass('hidden');
		});

		// cancel editing the email message
		$('.eb-cancel-message-btn').on('click', function onCancelMessageUpdateClick(e) {
			e.preventDefault();

			$('.eb-message-edit').addClass('hidden');
			$('.eb-message-preview').removeClass('hidden');
		});

		// preview the updated email message
		$('.eb-preview-message-btn').on('click', function onPreviewMessageClick(e) {
			var $message_field    = $('#' + form_id + 'message').first();
			var message           = null;
			var validation_errors = [];

			e.preventDefault();

			$('.eb-message-edit').find('.has-error').removeClass('has-error');

			if (message_editor) {
				message = message_editor.getContent();
			}

			// make sure some content is entered
			if (!message) {
				validation_errors.push({
					field: $message_field,
					error: 'The Message is required',
				});

				_highlightErrorFields(validation_errors);
				Adzuki.Form.throwSubmissionError(_getValidationErrorMessage(validation_errors));
				return;
			}

			// update email message preview
			if (message_editor) {
				$('.eb-message-container').html(message);
			}

			// go back to preview the email message
			$('.eb-message-edit').addClass('hidden');
			$('.eb-message-preview').removeClass('hidden');
		});

		// we are loading in 'edit' mode, default banner and message to edit view
		if (design_mode === 'edit') {
			$('.eb-update-banner-btn').trigger('click');
			$('.eb-update-message-btn').trigger('click');
		}

		// event handlers for any existing ctas
		$('.eb-cta-container').each(function onEachCtaContainer(i, elem) {
			var $cta_container = $(elem);

			_addEventHandlersToCtas($cta_container);

			// we are loading in 'edit' mode, default to edit view
			if (design_mode === 'edit') {
				$cta_container.find('.eb-edit-cta-btn').first().trigger('click');
			}
		});

		// event handlers for any existing content blocks
		$('.eb-cb-container').each(function onEachCbContainer(i, elem) {
			var $cb_container   = $(elem);
			var $content_field  = $cb_container.find('.cb-content-field').first();
			var $offer_field    = $cb_container.find('.cb-offers-field').first();
			var $skip_field     = $cb_container.find('.cb-skip-field').first();
			var layout_id       = parseInt($('#' + form_id + 'email_builder_layout_id').val());
			var content_type    = null;
			var trigger_preview = false ;

			_addEventHandlersToContentBlocks($cb_container);

			$cb_container.find('.cb-element-type-field:checked').trigger('change');
			content_type = $cb_container.find('.cb-element-type-field:checked').val();

			if (parseInt($skip_field.val()) === 0) {
				if (
					(content_type === 'offer_block' && $offer_field.val() !== '') ||
					(content_type === 'content_block' && $content_field.val() !== '')
				) {
					trigger_preview = true;
				}
			}

			// trigger the click on the content block only if it
			// has the appropriate data and is not hidden
			if (trigger_preview) {
				$cb_container.find('.eb-preview-cb-btn').first().trigger('click');
			}

			// we are loading in 'edit' mode, default to edit view
			if (layout_id === 2 && design_mode === 'edit') {
				$cb_container.find('.eb-edit-cb-btn').first().trigger('click');
			}
		});

		// event handlers for any existing content image blocks
		$('.eb-cib-container').each(function onEachCibContainer(i, elem) {
			var $cib_container  = $(elem);
			var $content_field  = $cib_container.find('.cib-content-field').first();
			var $offer_field    = $cib_container.find('.cib-offers-field').first();
			var $image_field    = $cib_container.find('.cib-image-field').first();
			var $pos_field      = $cib_container.find('.cib-position-field').first();
			var $skip_field     = $cib_container.find('.cib-skip-field').first();
			var layout_id       = parseInt($('#' + form_id + 'email_builder_layout_id').val());
			var content_type    = null;
			var trigger_preview = false;

			_addEventHandlersToContentImageBlocks($cib_container);

			$cib_container.find('.cib-element-type-field:checked').trigger('change');
			content_type = $cib_container.find('.cib-element-type-field:checked').val();

			if (parseInt($skip_field.val()) === 0) {
				if (
					(content_type === 'offer_block' && $offer_field.val() !== '') ||
					(
						content_type === 'content_image_block'
						&& $content_field.val() !== ''
						&& $image_field.val() !== ''
						&& $pos_field.val() !== ''
					)
				) {
					trigger_preview = true;
				}
			}

			// trigger the click on the content image block only if it
			// has the appropriate data and is not hidden
			if (trigger_preview) {
				$cib_container.find('.eb-preview-cib-btn').first().trigger('click');
			}

			// we are loading in 'edit' mode, default to edit view
			if (layout_id === 3 && design_mode === 'edit') {
				$cib_container.find('.cib-position-field').first().trigger('change');
				$cib_container.find('.eb-edit-cib-btn').first().trigger('click');
			}
		});

		// click handlers to add a new content block
		_addClickHandlersToInsertContentBlocks();

		// click handlers to add a new content image block
		_addClickHandlersToInsertContentImageBlocks();

		// if we are creating a new email from a template
		// update attributes on CTAs that came from the template
		if (
			!email_builder_id
			&& email_builder_type === 'email'
			&& $('#' + form_id + 'template_id').val()
		) {
			_updateCtaAttributesFromTemplate($('#' + form_id + 'template_id').val());
		}
	};

	form.success = function success(response)
	{
		if (Adzuki.Form.hasError(response)) {
			$('#' + form_id + 'save_draft').val(0);

			return false;
		}

		window.location.href = response['data'];

		return true;
	};

	function _addClickHandlersToInsertContentBlocks()
	{
		$('.eb-insert-cb').off().on('click', function onInsertCbClick(e) {
			var $self                     = $(this);
			var index                     = 0;
			var $new_cb_container         = null;
			var $prev_cb_container        = null;
			var $row_above                = null;
			var $new_cb_row               = null;
			var $new_insert_cb_button_row = null;
			var $cur_cb_row               = null;
			var $cur_cb_container         = null;
			var layout_id                 = $('#' + form_id + 'email_builder_layout_id').val();

			e.preventDefault();

			// wrong layout: no soup for you!
			if (parseInt(layout_id) !== 2) {
				return;
			}

			// if we are adding a new content block, and there are none displayed
			// then we should just display the first one
			if (
				$('.eb-cb-row').length === 1
				&& $('.eb-cb-container').length === 1
				&& $('.eb-cb-row').first().hasClass('first-hidden')
			) {
				$cur_cb_row       = $('.eb-cb-row').first();
				$cur_cb_container = $cur_cb_row.find('.eb-cb-container').first();

				_resetFieldsOnContentBlockContainer($cur_cb_container);
				_updateContentBlockOrdering();

				$cur_cb_row.removeClass('first-hidden hidden');

				$cur_cb_container.find('.eb-cb-preview').first().removeClass('hidden');
				$cur_cb_container.find('.eb-cb-edit').first().removeClass('hidden');
				$cur_cb_container.find('.eb-edit-cb-btn').first().trigger('click');

				// set skip to 0 so that the CTA is created
				$cur_cb_container.find('.cb-skip-field').first().val('0');

				// reset standalone status
				$cur_cb_container.find('.cb-standalone-field').first().val('0');

				return;
			}

			// figure out the index of the next content block we need to add
			index = _getNextContentBlockIndex();

			// clone the first content block container and update attributes and fields
			$new_cb_container = $('.eb-cb-container').first().clone(false);
			$new_cb_container.removeClass('hidden');

			_updateIndexOnContentBlockContainer($new_cb_container, index);
			_resetFieldsOnContentBlockContainer($new_cb_container);

			// figure out where to insert this new content block
			$row_above = $self.parents('.eb-insert-cb-row').prev('.eb-cb-row');

			// if there is room in the row above, insert it there
			if ($row_above.find('.eb-cb-container').length < 2) {
				// both content blocks take half the row
				$prev_cb_container = $row_above.find('.eb-cb-container').first();

				$prev_cb_container.removeClass('col-sm-6 col-sm-12').addClass('col-sm-6');
				$prev_cb_container.find('.cb-size-field').first().val('1-column');
				$prev_cb_container.find('.cb-standalone-field').first().val('0');

				// update resize icon on the other content block
				_updateResizeIcon($row_above.find('.eb-resize-cb-btn').first(), 'open');

				$new_cb_container.removeClass('col-sm-6 col-sm-12').addClass('col-sm-6');
				$new_cb_container.find('.cb-size-field').first().val('1-column');
				$new_cb_container.find('.cb-standalone-field').first().val('0');

				// update resize icon on the newly created content block
				_updateResizeIcon($new_cb_container.find('.eb-resize-cb-btn').first(), 'open');

				$row_above.append($new_cb_container);
			} else {
				// otherwise insert a new row below with the content block full-width
				$new_cb_row = $('<div class="eb-cb-row row margin20-top"></div>');
				$new_cb_row.insertAfter($self.parents('.eb-insert-cb-row'));

				$new_cb_container.removeClass('col-sm-6 col-sm-12').addClass('col-sm-12')
				.find('.cb-size-field').first().val('2-columns');

				// update resize icon on the newly created content block
				_updateResizeIcon($new_cb_container.find('.eb-resize-cb-btn').first(), 'close');

				$new_cb_row.append($new_cb_container);

				// clone a new "Insert New Content Block" button and add it below this new row
				$new_insert_cb_button_row = $('.eb-insert-cb-row').first().clone(false);
				$new_insert_cb_button_row.insertAfter($new_cb_row);
			}

			_addEventHandlersToContentBlocks($new_cb_container, index);
			_addClickHandlersToInsertContentBlocks();
			_updateContentBlockOrdering();

			// open up the view to edit the content block
			$new_cb_container.find('.eb-edit-cb-btn').first().trigger('click');
		});
	}

	function _addClickHandlersToInsertContentImageBlocks()
	{
		$('.eb-insert-cib').off().on('click', function onInsertCibClick(e) {
			var $self                      = $(this);
			var index                      = 0;
			var $new_cib_container         = null;
			var $prev_cib_container        = null;
			var $row_above                 = null;
			var $new_cib_row               = null;
			var $new_insert_cib_button_row = null;
			var new_offer_block            = false;
			var $cur_cib_row               = null;
			var $cur_cib_container         = null;
			var layout_id                  = $('#' + form_id + 'email_builder_layout_id').val();

			e.preventDefault();

			// wrong layout: no soup for you!
			if (parseInt(layout_id) !== 3) {
				return;
			}

			// if we are adding a new content image block, and there are none displayed
			// then we should just display the first one
			if (
				$('.eb-cib-row').length === 1
				&& $('.eb-cib-container').length === 1
				&& $('.eb-cib-row').first().hasClass('first-hidden')
			) {
				$cur_cib_row       = $('.eb-cib-row').first();
				$cur_cib_container = $cur_cib_row.find('.eb-cib-container').first();

				_resetFieldsOnContentImageBlockContainer($cur_cib_container);
				_updateContentImageBlockOrdering();
				_updateContentImageBlockRadio($cur_cib_container, 'enabled');

				$cur_cib_row.removeClass('first-hidden hidden');

				$cur_cib_container.find('.eb-cib-preview').first().removeClass('hidden');
				$cur_cib_container.find('.eb-cib-edit').first().removeClass('hidden');
				$cur_cib_container.find('.eb-cib-upload').first().removeClass('hidden');
				$cur_cib_container.find('.eb-edit-cib-btn').first().trigger('click');

				// set skip to 0 so that the CTA is created
				$cur_cib_container.find('.cib-skip-field').first().val('0');

				// reset standalone status
				$cur_cib_container.find('.cib-standalone-field').first().val('0');

				return;
			}

			// figure out the index of the next content image block we need to add
			index = _getNextContentImageBlockIndex();

			// clone the first content image block container and update attributes and fields
			$new_cib_container = $('.eb-cib-container').first().clone(false);
			$new_cib_container.removeClass('hidden');

			_updateIndexOnContentImageBlockContainer($new_cib_container, index);
			_resetFieldsOnContentImageBlockContainer($new_cib_container);

			// figure out where to insert this new content image block
			$row_above = $self.parents('.eb-insert-cib-row').prev('.eb-cib-row');

			// the row above is an offer block that takes the entire row, there is room, insert there
			if (
				$row_above.find('.eb-cib-container').length < 2
				&& $row_above.find('.cib-element-type-field[value="offer_block"]').first().is(':checked')
			) {
				// both content blocks take half the row
				$prev_cib_container = $row_above.find('.eb-cib-container').first();

				$prev_cib_container.removeClass('col-sm-6 col-sm-12').addClass('col-sm-6');
				$prev_cib_container.find('.cib-size-field').first().val('1-column');
				$prev_cib_container.find('.cib-standalone-field').first().val('0');

				// update resize icon on the other offer-based content image block
				_updateResizeIcon($row_above.find('.eb-resize-cib-btn').first(), 'open');
				_updateContentImageBlockRadio($prev_cib_container, 'disabled');

				$new_cib_container.removeClass('col-sm-6 col-sm-12').addClass('col-sm-6');
				$new_cib_container.find('.cib-size-field').first().val('1-column');
				$new_cib_container.find('.cib-standalone-field').first().val('0');

				// update resize icon on this newly created offer-based content image block
				_updateResizeIcon($new_cib_container.find('.eb-resize-cib-btn').first(), 'open');
				_updateContentImageBlockRadio($new_cib_container, 'disabled');

				// insert the content image block into the DOM
				$row_above.append($new_cib_container);

				// this is a new offer block
				new_offer_block = true;
			} else {
				// otherwise insert a new row below with the new content image block
				$new_cib_row = $('<div class="eb-cib-row row margin20-top"></div>');
				$new_cib_row.insertAfter($self.parents('.eb-insert-cib-row'));

				$new_cib_container.removeClass('col-sm-6 col-sm-12').addClass('col-sm-12')
				.find('.cib-size-field').first().val('2-columns');

				// update resize icon on the newly created content image block
				_updateResizeIcon($new_cib_container.find('.eb-resize-cib-btn').first(), 'close');
				_updateContentImageBlockRadio($new_cib_container, 'enabled');

				// insert the content image block into the DOM
				$new_cib_row.append($new_cib_container);

				// clone a new "Insert New Content Image Block" button and add it below this new row
				$new_insert_cib_button_row = $('.eb-insert-cib-row').first().clone(false);
				$new_insert_cib_button_row.insertAfter($new_cib_row);
			}

			_addEventHandlersToContentImageBlocks($new_cib_container, index);
			_addClickHandlersToInsertContentImageBlocks();
			_updateContentImageBlockOrdering();
			_initMediaHubInContainer($new_cib_container);

			// this is a new offer block, select the "select offer" radio option
			if (new_offer_block) {
				_selectContentImageBlockRadioOption($new_cib_container, 'offer', true);
			}

			// open up the view to edit the content image block
			$new_cib_container.find('.eb-edit-cib-btn').first().trigger('click');
		});
	}

	async function _addCruiseVendorOptions()
	{
		const $vendor_select = $('#' + form_id + 'vendor_select');

		try {
			const response = await Adzuki.Ajax.get('/Vendors/getCruiseVendorOptions');

			$vendor_select.find('option').not(':first').remove();

			for (const [vendor_id, vendor] of Object.entries(response)) {
				$vendor_select.append($('<option>', {
					value: vendor_id,
					text : vendor,
				}));
			}
		} catch (error) {
			return Adzuki.StatusMessage('error', error.message, 'Error!');
		}
	}

	function _addDaysOptions(days, send_out_select)
	{
		for (const [i, day] of Object.entries(days)) {
			send_out_select.append($('<option>', {
				value: i,
				text : day
			}));
		}
	}

	function _addEventHandlersToContentBlocks($cb_container, idx)
	{
		var $cb_preview = $cb_container.find('.eb-cb-preview').first();
		var $cb_edit    = $cb_container.find('.eb-cb-edit').first();
		var index       = idx;

		// no index was passed, take it from the element
		if (!index) {
			index = $cb_container.data('index');
		}

		// show the form to edit the content block
		$cb_container.find('.eb-edit-cb-btn').first().off().on('click', function onEditCbBtnClick(e) {
			e.preventDefault();

			$cb_preview.addClass('hidden');
			$cb_edit.removeClass('hidden');
		});

		// remove the content block
		$cb_container.find('.eb-remove-cb-btn').first().off().on('click', function onRemoveCbBtnClick(e) {
			var $row       = $(this).parents('.eb-cb-row').first();
			var cbs_in_row = $row.find('.eb-cb-container').length;

			e.preventDefault();

			// if we are removing the only content block left, we should just hide it
			if (
				$('.eb-cb-container').length === 1
				&& cbs_in_row === 1
			) {
				$row.addClass('first-hidden hidden');
				$row.find('.eb-cb-preview').first().addClass('hidden');
				$row.find('.eb-cb-edit').first().addClass('hidden');

				_updateContentBlockOrdering();

				// set skip to 1 so that the content block is not created
				$row.find('.cb-skip-field').first().val('1');

				// reset standalone status
				$row.find('.cb-standalone-field').first().val('0');

				return;
			}

			// remove content block from the DOM
			$(this).parents('.eb-cb-container').remove();

			// if there are 2(two!) content blocks on this row,
			// then the content block left should take the entire row
			// otherwise, remove the row
			if (cbs_in_row > 1) {
				$row.find('.eb-cb-container').first()
				.removeClass('col-sm-6 col-sm-12').addClass('col-sm-12')
				.find('.cb-size-field').first().val('2-columns')
				.find('.cb-standalone-field').first().val('0');

				_updateResizeIcon($row.find('.eb-resize-cb-btn').first(), 'close');
			} else {
				// remove the "Insert New Content Block" button for this row
				$row.next('.eb-insert-cb-row').remove();

				// remove the row
				$row.remove();
			}

			_updateContentBlockOrdering();
		});

		// show the preview with the new changes on the content block
		$cb_container.find('.eb-preview-cb-btn').first().off().on('click', function onPreviewCbBtnClick(e) {
			var $element_type_field = $cb_container.find('.cb-element-type-field:checked').first();
			var element_type        = $element_type_field.val();
			var $content_field      = $cb_container.find('.cb-content-field').first();
			var $offer_field        = $cb_container.find('.cb-offers-field').first();
			var offer_id            = $offer_field.val();
			var $size_field         = $cb_container.find('.cb-size-field').first();
			var selected_cb_size    = $size_field.val();
			var cur_cb_size         = '1-column';
			var validation_errors   = [];

			e.preventDefault();

			$cb_container.find('.eb-cb-edit .has-error').removeClass('has-error');

			// check what is the size of the content block right now
			if ($cb_container.hasClass('col-sm-12')) {
				cur_cb_size = '2-columns';
			}

			if (element_type === 'offer_block') {
				if (!offer_id) {
					validation_errors.push({
						field: $offer_field,
						error: 'You must select an offer',
					});

					_highlightErrorFields(validation_errors);
					Adzuki.Form.throwSubmissionError(_getValidationErrorMessage(validation_errors));
					return;
				}

				// selecting an offer
				Adzuki.Ajax.get('/EmailBuilders/offerContentBlock/' + offer_id)
				.then(function getOfferDetails(response) {
					// add content from the offer into the content block
					$cb_container.find('.eb-cb-content').first().html(response);
				});
			} else {
				// make sure some content is entered
				if (!$content_field.val()) {
					validation_errors.push({
						field: $content_field,
						error: 'The content of the content block is required',
					});

					_highlightErrorFields(validation_errors);
					Adzuki.Form.throwSubmissionError(_getValidationErrorMessage(validation_errors));
					return;
				}

				// add content from textarea into the content block
				$cb_container.find('.eb-cb-content').first().html($content_field.val());
			}

			// resize the content block?
			if (cur_cb_size !== selected_cb_size) {
				_resizeContentBlock($cb_container.find('.eb-resize-cb-btn').first());
			}

			// show the preview with changes
			$cb_preview.removeClass('hidden');
			$cb_edit.addClass('hidden');
		});

		// cancel the changes on the content block
		$cb_container.find('.eb-cancel-cb-edit-btn').first().off().on('click', function onCancelCbBtnClick(e) {
			e.preventDefault();

			$cb_preview.removeClass('hidden');
			$cb_edit.addClass('hidden');
		});

		// resize the content block
		$cb_container.find('.eb-resize-cb-btn').first().off().on('click', function onResizeCbBtnClick(e) {
			var $self = $(this);

			e.preventDefault();

			_resizeContentBlock($self);
		});

		// when changing the view between "Enter Content" and "Offers"
		$cb_container.find('.cb-element-type-field').off().on('change', function onCbContentTypeChange(e) {
			var element_type    = $(this).val();
			var $content_fields = $cb_container.find('.eb-cb-content-fields').first();
			var $offer_fields   = $cb_container.find('.eb-cb-offer-fields').first();

			if (element_type === 'offer_block') {
				$content_fields.addClass('hidden');
				$offer_fields.removeClass('hidden');

				return;
			}

			$offer_fields.addClass('hidden');
			$content_fields.removeClass('hidden');
		});

		// initialize the text editor
		Adzuki.Editor('#' + form_id + 'content_blocks-' + index + '-content', {
			editor_type: editor_type,
		});
	}

	function _addEventHandlersToContentImageBlocks($cib_container, idx)
	{
		var $cib_preview = $cib_container.find('.eb-cib-preview').first();
		var $cib_edit    = $cib_container.find('.eb-cib-edit').first();
		var $cib_upload  = $cib_container.find('.eb-cib-upload').first();
		var index        = idx;

		// no index was passed, take it from the element
		if (!index) {
			index = $cib_container.data('index');
		}

		// show the form to edit the content image block
		$cib_container.find('.eb-edit-cib-btn').first().off().on('click', function onEditCibBtnClick(e) {
			e.preventDefault();

			$cib_preview.addClass('hidden');
			$cib_upload.addClass('hidden');
			$cib_edit.removeClass('hidden');
		});

		// remove the content image block
		$cib_container.find('.eb-remove-cib-btn').first().off().on('click', function onRemoveCibBtnClick(e) {
			var $row        = $(this).parents('.eb-cib-row').first();
			var cibs_in_row = $row.find('.eb-cib-container').length;

			e.preventDefault();

			// if we are removing the only content image block left, we should just hide it
			if (
				$('.eb-cib-container').length === 1
				&& cibs_in_row === 1
			) {
				$row.addClass('first-hidden hidden');
				$row.find('.eb-cib-preview').first().addClass('hidden');
				$row.find('.eb-cib-edit').first().addClass('hidden');
				$row.find('.eb-cib-upload').first().addClass('hidden');

				_updateContentImageBlockOrdering();

				// set skip to 1 so that the content image block is not created
				$row.find('.cib-skip-field').first().val('1');

				// reset standalone status
				$row.find('.cib-standalone-field').first().val('0');

				return;
			}

			// remove content image block from the DOM
			$(this).parents('.eb-cib-container').remove();

			// if there are 2(two!) offer-based content image blocks on this row,
			// then the offer-based content image block left should take the entire row
			// otherwise, also remove the row
			if (cibs_in_row > 1) {
				$row.find('.eb-cib-container').first()
				.removeClass('col-sm-6 col-sm-12').addClass('col-sm-12')
				.find('.cib-size-field').first().val('2-columns')
				.find('.cib-standalone-field').first().val('0');

				_updateResizeIcon($row.find('.eb-resize-cib-btn').first(), 'close');
			} else {
				// remove the "Insert New Content Image Block" button for this row
				$row.next('.eb-insert-cib-row').remove();

				// remove the row
				$row.remove();
			}

			_updateContentImageBlockOrdering();
		});

		// show the preview with the new changes on the content image block
		$cib_container.find('.eb-preview-cib-btn').first().off().on('click', function onPreviewCibBtnClick(e) {
			var $element_type_field = $cib_container.find('.cib-element-type-field:checked').first();
			var element_type        = $element_type_field.val();
			var $resize_btn         = $cib_container.find('.eb-resize-cib-btn').first();
			var $offer_field        = $cib_container.find('.cib-offers-field').first();
			var offer_id            = $offer_field.val();
			var $content_field      = $cib_container.find('.cib-content-field').first();
			var content             = $content_field.val();
			var $position_field     = $cib_container.find('.cib-position-field').first();
			var position            = $position_field.val();
			var $image_field        = $cib_container.find('.cib-image-field').first();
			var image_id            = $image_field.val();
			var $size_field         = $cib_container.find('.cib-size-field').first();
			var selected_cib_size   = $size_field.val();
			var cur_cb_size         = '1-column';
			var validation_errors   = [];
			var post_data           = {
				content : content,
				position: position,
				image_id: image_id,
			};

			e.preventDefault();

			$cib_container.find('.eb-cib-edit .has-error').removeClass('has-error');

			// check what is the size of the content image block right now
			if ($cib_container.hasClass('col-sm-12')) {
				cur_cb_size = '2-columns';
			}

			if (element_type === 'offer_block') {
				if (!offer_id) {
					validation_errors.push({
						field: $offer_field,
						error: 'You must select an offer',
					});

					_highlightErrorFields(validation_errors);
					Adzuki.Form.throwSubmissionError(_getValidationErrorMessage(validation_errors));
					return;
				}

				// selecting an offer
				Adzuki.Ajax.get('/EmailBuilders/offerContentBlock/' + offer_id)
				.then(function getOfferDetails(response) {
					// add content from the offer into the content image block
					$cib_container.find('.eb-cib-content').first().html(response);
				});

				// show button to resize this offer block
				$resize_btn.removeClass('hidden');

				// resize the offer-based content image block
				if (cur_cb_size !== selected_cib_size) {
					_resizeOfferContentImageBlock($cib_container.find('.eb-resize-cib-btn').first());
				}

				// disable the radio to enter the content if the offer only takes half the row
				if (selected_cib_size === '1-column') {
					_updateContentImageBlockRadio($cib_container, 'disabled');
				} else {
					_updateContentImageBlockRadio($cib_container, 'enabled');
				}
			} else {
				// regular content image block, make sure the content is there
				if (!content) {
					validation_errors.push({
						field: $content_field,
						error: 'The content of the block is required',
					});
				}

				if (!position) {
					validation_errors.push({
						field: $position_field,
						error: 'The Position is required',
					});
				}

				if (!image_id) {
					validation_errors.push({
						field: $image_field,
						error: 'The Image is required',
					});
				}

				if (validation_errors.length > 0) {
					_highlightErrorFields(validation_errors);
					Adzuki.Form.throwSubmissionError(_getValidationErrorMessage(validation_errors));
					return;
				}

				// this is a regular content image block, remove resize button
				$resize_btn.addClass('hidden');

				Adzuki.Ajax.post('/EmailBuilders/contentImageBlock', post_data)
				.then(function updateContentImageBlock(response) {
					// set the html content for the image block
					$cib_container.find('.eb-cib-content').html(response);
				});
			}

			// show the preview with changes
			$cib_preview.removeClass('hidden');
			$cib_edit.addClass('hidden');
			$cib_upload.addClass('hidden');
		});

		// resize the content image block (only for offers)
		$cib_container.find('.eb-resize-cib-btn').first().off().on('click', function onResizeCibBtnClick(e) {
			var $self = $(this);

			e.preventDefault();

			_resizeOfferContentImageBlock($self);
		});

		// cancel the changes on the content image block
		$cib_container.find('.eb-cancel-cib-btn').first().off().on('click', function onCancelCibBtnClick(e) {
			e.preventDefault();

			$cib_preview.removeClass('hidden');
			$cib_edit.addClass('hidden');
			$cib_upload.addClass('hidden');
		});

		// when changing the view between "Enter Content/Image" and "Offers"
		$cib_container.find('.cib-element-type-field').off().on('change', function onCibContentTypeChange(e) {
			var element_type    = $(this).val();
			var $content_fields = $cib_container.find('.eb-cib-content-fields').first();
			var $offer_fields   = $cib_container.find('.eb-cib-offer-fields');

			if (element_type === 'offer_block') {
				$content_fields.addClass('hidden');
				$offer_fields.removeClass('hidden');

				return;
			}

			$offer_fields.addClass('hidden');
			$content_fields.removeClass('hidden');
		});

		// update the available images when changing the position of the image
		$cib_container.find('.cib-position-field').first().off()
		.on('change', function onImagePositionChange(e) {
			var position = $(this).val();

			_reloadImageOptions(null, index, position);
		});

		// click to view the form to upload a custom image
		$cib_container.find('.eb-upload-custom-image-btn').first().off()
		.on('click', function onUploadCustomImageBtnClick(e) {
			e.preventDefault();

			$cib_upload.removeClass('hidden');
			$cib_preview.addClass('hidden');
			$cib_edit.addClass('hidden');
		});

		// submit the form to upload a custom image
		$cib_container.find('.eb-upload-image-btn').first().off()
		.on('click', function onUploadImageBtnClick(e) {
			var $self                    = $(this);
			var $image_upload_container  = $cib_container.find('.eb-cib-upload').first();
			var $mediahub_dragdrop       = $cib_container.find('.mh-dragdrop-container').first();
			var $image_pos_input         = $('#' + form_id + 'content_image_blocks-' + index + '-image_position');
			var $image_name_input        = $('#' + form_id + 'content_image_blocks-' + index + '-image_name');
			var $image_media_id_input    = $cib_container.find('.cib-image-media-id-field').first();
			var media_ids                = $image_media_id_input.val();

			var image_position           = $image_pos_input.val();
			var image_name               = $image_name_input.val();
			var post_data                = null;

			e.preventDefault();

			if (
				$mediahub_dragdrop.length
				&& typeof Adzuki.MediaHubDragDrop !== 'undefined'
				&& Adzuki.MediaHubDragDrop.hasPendingUploads($mediahub_dragdrop[0])
			) {
				Adzuki.Form.throwSubmissionError('Please wait for Media Hub uploads to finish before uploading the image.');
				return;
			}

			post_data = {
				image_position: image_position,
				image_name    : image_name,
				media_ids     : media_ids,
				settings      : null,
			};

			$image_upload_container.find('.fLoader').css('visibility', 'visible');
			$image_upload_container.find('.has-error').removeClass('has-error');
			$self.attr('disabled', true);

			Adzuki.Ajax.post('/EmailBuilders/uploadCustomContent/image', post_data)
			.then(function uploadCustomContent(response) {
				var position        = 'top';
				var $position_field = $('#' + form_id + 'content_image_blocks-' + index + '-content_block_image_position');

				$image_upload_container.find('.fLoader').css('visibility', 'hidden');
				$self.attr('disabled', false);

				// there was a problem uploading the custom image
				if (response.error) {
					_highlightErrorFields(response.error);
					Adzuki.Form.throwSubmissionError(_getValidationErrorMessage(response.error));
					return;
				}

				// custom image uploaded, clear fields for the next submission
				$image_name_input.val('');
				$image_pos_input.val('left_right');
				$image_media_id_input.val('');
				_resetMediaHubDragDrop($cib_container);

				if (image_position.includes('left')) {
					position = 'left';
				}

				// update select input options and select the uploaded image
				_reloadImageOptions(response.image_id, index, position);

				// update the position field on the content image block
				$position_field.val(position);

				// go back to editing the content image block
				$cib_edit.removeClass('hidden');
				$cib_preview.addClass('hidden');
				$cib_upload.addClass('hidden');
			});
		});

		// cancel the upload of a custom image
		$cib_container.find('.eb-cancel-image-upload-btn').first().off()
		.on('click', function onCancelImageUploadBtnClick(e) {
			e.preventDefault();

			$cib_edit.removeClass('hidden');
			$cib_preview.addClass('hidden');
			$cib_upload.addClass('hidden');
		});

		// initialize the text editor
		Adzuki.Editor('#' + form_id + 'content_image_blocks-' + index + '-content', {
			editor_type: editor_type,
		});

		// initialize handlers for the visual list
		Adzuki.VisualList.init();
	}

	function _addEventHandlersToCtas($cta_container)
	{
		var $cta_preview        = $cta_container.find('.eb-cta-preview').first();
		var $cta_edit           = $cta_container.find('.eb-cta-edit').first();
		var $action_field       = $cta_container.find('.cta-action-field').first();
		var $text_color_field   = $cta_container.find('.cta-text-color-field').first();
		var $border_color_field = $cta_container.find('.cta-border-color-field').first();
		var selected_action_id  = null;

		// button to add a new CTA
		$cta_container.find('.eb-insert-cta').first().off().on('click', function onInsertCtaClick(e) {
			var $self              = $(this);
			var $new_cta_container = null;
			var $cur_cta_container = null;
			var index              = 0;

			e.preventDefault();

			// if we are adding a new CTA, and there are none displayed
			// then we should just display the first one
			if (
				$('.eb-cta-container').length === 1
				&& $('.eb-cta-container').first().hasClass('first-hidden')
			) {
				$cur_cta_container = $('.eb-cta-container').first();

				_resetFieldsOnCtaContainer($cur_cta_container, true);
				_updateCtaOrdering();

				$cur_cta_container.removeClass('first-hidden');
				$cur_cta_container.find('.eb-cta-preview').first().removeClass('hidden');
				$cur_cta_container.find('.eb-cta-edit').first().removeClass('hidden');
				$cur_cta_container.find('.eb-edit-cta-btn').first().trigger('click');

				// set skip to 0 so that the CTA is created
				$cur_cta_container.find('.cta-skip-field').first().val('0');

				return;
			}

			// figure out the index of the next CTA we need to add
			index = _getNextCTAIndex();

			// clone the first CTA container and update attributes and fields
			$new_cta_container = $('.eb-cta-container').first().clone(false);
			$new_cta_container.removeClass('hidden');

			_updateIndexOnCtaContainer($new_cta_container, index);
			_resetFieldsOnCtaContainer($new_cta_container, true);

			// insert the new CTA
			$new_cta_container.insertAfter($self.parents('.eb-cta-container'));

			_addEventHandlersToCtas($new_cta_container);
			_updateCtaOrdering();
			_initMediaHubInContainer($new_cta_container);

			// open up the view to edit the CTA
			$new_cta_container.find('.eb-edit-cta-btn').first().trigger('click');
		});

		// show the form to edit the CTA
		$cta_container.find('.eb-edit-cta-btn').first().off().on('click', function onEditCtaBtnClick(e) {
			e.preventDefault();

			$cta_preview.addClass('hidden');
			$cta_edit.removeClass('hidden');
		});

		// remove the CTA
		$cta_container.find('.eb-remove-cta-btn').first().off().on('click', function onRemoveCtaBtnClick(e) {
			var $cur_cta_container = null;

			e.preventDefault();

			// if we are removing the only CTA left, we should just hide it
			if ($('.eb-cta-container').length === 1) {
				$cur_cta_container = $('.eb-cta-container').first();

				$cur_cta_container.addClass('first-hidden');
				$cur_cta_container.find('.eb-cta-preview').first().addClass('hidden');
				$cur_cta_container.find('.eb-cta-edit').first().addClass('hidden');

				_updateCtaOrdering();

				// set skip to 1 so that the CTA is not created
				$cur_cta_container.find('.cta-skip-field').first().val('1');

				return;
			}

			// remove CTA from the DOM
			$(this).parents('.eb-cta-container').remove();

			_updateCtaOrdering();
		});

		// show the preview with the new changes on the CTA
		$cta_container.find('.eb-preview-cta-btn').first().off().on('click', function onPreviewCtaBtnClick(e) {
			var $action_field       = $cta_container.find('.cta-action-field').first();
			var $text_field         = $cta_container.find('.cta-text-field').first();
			var $text_color_field   = $cta_container.find('.cta-text-color-field').first();
			var $border_color_field = $cta_container.find('.cta-border-color-field').first();
			var action_id           = $action_field.val();
			var text                = $text_field.val();
			var text_color          = $text_color_field.val();
			var border_color        = $border_color_field.val();
			var cta_data            = {};
			var validation_errors   = [];
			var entity_type         = null;
			var $entity_field       = null;
			console.log('container click', $cta_container, 'action', action_id);
			e.preventDefault();

			$action_field.parents('.form-group').removeClass('has-error');
			$text_field.parents('.form-group').removeClass('has-error');

			// validate fields
			if (!action_id) {
				validation_errors.push({
					field: $action_field,
					error: 'The Action of the Call to Action is required',
				});
			}

			if (!text) {
				validation_errors.push({
					field: $text_field,
					error: 'The Text of the Call to Action is required',
				});
			}

			if (action_id) {
				switch (parseInt(action_id)) {
					case 5: // where2next-event
						entity_type        = 'Where2next Event';
						$entity_field      = $cta_container.find('.cta-w2n-field').first();
						cta_data.entity_id = $entity_field.val();
						break;
					case 6: // testimonial
						cta_data.link_url = $cta_container.find('.cta-link-url-field').first().val();
						break;
					case 7: // client-lead-form
						entity_type        = 'Client Form';
						$entity_field      = $cta_container.find('.cta-client-form-field').first();
						cta_data.entity_id = $entity_field.val();
						break;
					case 11: // cruise-sheet
						entity_type        = 'Cruise Sheet';
						$entity_field      = $cta_container.find('.cta-cs-field').first();
						cta_data.entity_id = $entity_field.val();
						break;
					case 12: // trip-summary
						entity_type        = 'Trip Summary';
						$entity_field      = $cta_container.find('.cta-ts-field').first();
						cta_data.entity_id = $entity_field.val();
						break;
					case 13: // vendor-landing-page
						entity_type        = 'Vendor Landing Page';
						$entity_field      = $cta_container.find('.cta-vendor-page-field').first();
						cta_data.entity_id = $entity_field.val();
						break;
					case 14: // custom-cta
						cta_data.link_url = $cta_container.find('.cta-link-url-field').first().val();
						break;
					case 16: // video library
						entity_type        = 'Video';
						$entity_field      = $cta_container.find('.cta-video-field').first();
						cta_data.entity_id = $entity_field.val();
						break;
					case 17: // signature microsite
						entity_type        = 'Signature Microsite';
						$entity_field      = $cta_container.find('.cta-microsite-field').first();
						cta_data.entity_id = $entity_field.val();
						break;
					default:
						// nothing else to do here
				}
			}

			// validate entity field (if any)
			if (entity_type && !cta_data.entity_id) {
				validation_errors.push({
					field: $entity_field,
					error: 'The ' + entity_type + ' is required',
				});
			}

			if (validation_errors.length > 0) {
				_highlightErrorFields(validation_errors);
				Adzuki.Form.throwSubmissionError(_getValidationErrorMessage(validation_errors));
				return;
			}

			// basic CTA data
			cta_data.action_id    = action_id;
			cta_data.text         = text;
			cta_data.text_color   = text_color;
			cta_data.border_color = border_color;

			_updateCtaPreview($cta_container, cta_data);

			// show the preview with changes
			$cta_preview.removeClass('hidden');
			$cta_edit.addClass('hidden');
		});

		// cancel the changes on the CTA
		$cta_container.find('.eb-cancel-cta-edit-btn').first().off().on('click', function onCancelCtaBtnClick(e) {
			e.preventDefault();

			$cta_preview.removeClass('hidden');
			$cta_edit.addClass('hidden');
		});

		// init the character count for the CTA text
		Adzuki.CharacterCount($cta_container.find('.cta-text-field').first(), {
			max  : cta_character_count,
			label: $cta_container.find('.cta-text-count').first(),
		});

		// when changing the CTA action dropdown
		$action_field.off().on('change', function onCtaActionChange(e) {
			var action_id   = $(this).val();
			var $text_field = $cta_container.find('.cta-text-field').first();

			_resetFieldsOnCtaContainer($cta_container);

			// no action selected, then nothing else to do
			if (!action_id) {
				return;
			}

			Adzuki.Ajax.get('/EmailBuilders/getCtaActionTypeDetails/' + action_id)
			.then(function getCtaActionType(response) {
				var action_details = response;

				// there are different things to do depending on the action type selected
				switch (action_details.action) {
					case 'where2next-event':
						// display the event selection dropdown
						$cta_container.find('.w2n-events-field').first().removeClass('hidden');
						break;
					case 'cruise-sheet':
						// display the cruise sheet selection dropdown
						$cta_container.find('.cruise-sheet-field').first().removeClass('hidden');
						break;
					case 'trip-summary':
						// display the trip summary selection dropdown
						$cta_container.find('.trip-summary-field').first().removeClass('hidden');
						break;
					case 'vendor-landing-page':
						// display the vendor page selection dropdown
						$cta_container.find('.vendor-landing-field').first().removeClass('hidden');
						break;
					case 'client-lead-form':
						// display the client lead form selection dropdown
						$cta_container.find('.client-lead-form-field').first().removeClass('hidden');
						break;
					case 'testimonial':
						// display the field to specify a URL and update the text
						$cta_container.find('.link-url-field').first().removeClass('hidden');
						$text_field.val(action_details.action_default_text).trigger('input');
						break;
					case 'video-library':
						// display the video selection dropdown
						$cta_container.find('.video-field').first().removeClass('hidden');
						$text_field.val(action_details.action_default_text).trigger('input');
						break;
					case 'microsite':
						// display the signature microsite selection dropdown
						$cta_container.find('.microsite-field').first().removeClass('hidden');
						break;
					case 'custom-cta':
						// display the field to specify a URL
						$cta_container.find('.link-url-field').first().removeClass('hidden');
						break;
					default:
						// just update the action text
						$text_field.val(action_details.action_default_text).trigger('input');
				}

				// is there a duplicate? if so, display warning
				_checkForDuplicateCta(action_details.id, $cta_container);
			});
		});

		// when changing the selected w2n event on the CTA
		$cta_container.find('.cta-w2n-field').first().off().on('change', function onW2NCtaChange(e) {
			var virtual_event_id = $(this).val();

			_updateCtaTextDescription($cta_container, virtual_event_id);
		});

		// when changing the selected cruise sheet on the CTA
		$cta_container.find('.cta-cs-field').first().off().on('change', function onCsCtaChange(e) {
			var cruise_sheet_id = $(this).val();
			var $cta_text_field = $cta_container.find('.cta-text-field').first();

			// do not update the CTA text when the selected CS is changed
			// this happens when creating a new email from a template
			if ($cta_text_field.val() && $(this).attr('update-text') === '0') {
				return;
			}

			_updateCtaTextDescription($cta_container, cruise_sheet_id);
		});

		// when changing the selected trip summary on the CTA
		$cta_container.find('.cta-ts-field').first().off().on('change', function onTsCtaChange(e) {
			var trip_summary_id = $(this).val();
			var $cta_text_field = $cta_container.find('.cta-text-field').first();

			// do not update the CTA text when the selected TS is changed
			// this happens when creating a new email from a template
			if ($cta_text_field.val() && $(this).attr('update-text') === '0') {
				return;
			}

			_updateCtaTextDescription($cta_container, trip_summary_id);
		});

		// when changing the selected vendor landing page on the CTA
		$cta_container.find('.cta-vendor-page-field').first().off()
		.on('change', function onVendorPageCtaChange(e) {
			var vendor_landing_page_id = $(this).val();

			_updateCtaTextDescription($cta_container, vendor_landing_page_id);
		});

		// when changing the selected signature microsite on the CTA
		$cta_container.find('.cta-microsite-field').first().off()
		.on('change', function onMicrositeCtaChange(e) {
			var microsite_id = $(this).val();

			_updateCtaTextDescription($cta_container, microsite_id);
		});

		// when changing the selected video on the CTA
		$cta_container.find('.cta-video-field').first().off().on('change', function onVideoCtaChange(e) {
			var video_id = $(this).val();

			if (!video_id) {
				return;
			}

			// media hub may store comma-separated ids; use the first one
			video_id = String(video_id).split(',')[0];

			_updateCtaTextDescription($cta_container, video_id);
		});

		// if there is an action pre-selected, then display the appropriate entity dropdown (if it applies)
		if ($action_field.val()) {
			selected_action_id = parseInt($action_field.val());

			switch (selected_action_id) {
				case 5:
					// where2 next event link: display the event selection dropdown
					$cta_container.find('.w2n-events-field').first().removeClass('hidden');
					break;
				case 6:
					// testimonial: display the field to specify a URL
					$cta_container.find('.link-url-field').first().removeClass('hidden');
					break;
				case 7:
					// client lead form: display the client lead form selection dropdown
					$cta_container.find('.client-lead-form-field').first().removeClass('hidden');
					break;
				case 11:
					// cruise sheet: display the cruise sheet selection dropdown
					$cta_container.find('.cruise-sheet-field').first().removeClass('hidden');
					break;
				case 12:
					// trip summary: display the trip summary selection dropdown
					$cta_container.find('.trip-summary-field').first().removeClass('hidden');
					break;
				case 13:
					// vendor landing page: display the vendor page selection dropdown
					$cta_container.find('.vendor-landing-field').first().removeClass('hidden');
					break;
				case 14:
					// custom CTA: display the field to specify a URL
					$cta_container.find('.link-url-field').first().removeClass('hidden');
					break;
				case 16:
					// video library: display the video selection dropdown
					$cta_container.find('.video-field').first().removeClass('hidden');
					break;
				case 17:
					// signature microsite: display the signature microsite selection dropdown
					$cta_container.find('.microsite-field').first().removeClass('hidden');
					break;
				default:
					// nothing to do
			}

			// is there a duplicate? if so, display warning
			_checkForDuplicateCta(selected_action_id, $cta_container);
		}

		// init the text color colorpickers
		if ($text_color_field.val()) {
			picker_text_color = $text_color_field.val();
		}

		$text_color_field.val(picker_text_color).spectrum({
			color          : picker_text_color,
			preferredFormat: 'hex',
			showInitial    : true,
			showInput      : true,
			change         : function changeColor(color) {
				var new_color = color.toHexString().toUpperCase();
				$cta_container.find('.cta-text-color-field').first().val(new_color);
			}
		});

		// init the border colorpickers
		if ($border_color_field.val()) {
			picker_border_color = $border_color_field.val();
		}

		$border_color_field.val(picker_border_color).spectrum({
			color          : picker_border_color,
			preferredFormat: 'hex',
			showInitial    : true,
			showInput      : true,
			change         : function changeColor(color) {
				var new_color = color.toHexString().toUpperCase();
				$cta_container.find('.cta-border-color-field').first().val(new_color);
			}
		});
	}

	async function _addLodgingVendorOptions()
	{
		const $vendor_select = $('#' + form_id + 'vendor_select');

		try {
			const response = await Adzuki.Ajax.get('/Vendors/getLodgingVendorOptions');

			$vendor_select.find('option').not(':first').remove();

			for (const [vendor_id, vendor] of Object.entries(response)) {
				$vendor_select.append($('<option>', {
					value: vendor_id,
					text : vendor,
				}));
			}
		} catch (error) {
			return Adzuki.StatusMessage('error', error.message, 'Error!');
		}
	}

	async function _addPackageVendorOptions()
	{
		const $vendor_select = $('#' + form_id + 'vendor_select');

		try {
			const response = await Adzuki.Ajax.get('/Vendors/getPackageVendorOptions');

			$vendor_select.find('option').not(':first').remove();

			for (const [vendor_id, vendor] of Object.entries(response)) {
				$vendor_select.append($('<option>', {
					value: vendor_id,
					text : vendor,
				}));
			}
		} catch (error) {
			return Adzuki.StatusMessage('error', error.message, 'Error!');
		}
	}

	function _changeEventType(event_type, schedule_days, days_before_after = null, reset_vendor = false)
	{
		const $vendor_container          = $('.eb-vendor-container');
		const $dest_container            = $('.eb-destination-container');
		const $send_out_select           = $('#' + form_id + 'send_days_before_after');
		const $send_out_container        = $('.eb-send-out-container');
		const $send_out_label            = $('.eb-send-out-label');
		const days_after                 = schedule_days.days_after;
		const days_before                = schedule_days.days_before;
		const cruise_event_types         = schedule_days.cruise_event_types;
		const package_event_types        = schedule_days.package_event_types;
		const lodging_event_types        = schedule_days.lodging_event_types;
		const full_send_option_keys      = Object.keys(full_send_option);
		const seven_day_send_option_keys = Object.keys(seven_day_send_option);

		$vendor_container.addClass('hidden');
		$dest_container.addClass('hidden');
		$send_out_container.removeClass('hidden');
		$send_out_select.find('option').remove();

		// hide "Send Out" option for those event types that don't need it.
		if (no_send_option.includes(event_type)) {
			$send_out_container.addClass('hidden');
		}

		// these events use 7 days options list
		if (seven_day_send_option_keys.includes(event_type)) {
			_addDaysOptions(days_after, $send_out_select);

			if (days_before_after) {
				$send_out_select.val(days_before_after);
			} else {
				$send_out_select.val(seven_day_send_option[event_type]['day']);
			}

			$send_out_label.html('after ' + seven_day_send_option[event_type]['label']);
		}

		// these events use 180 days options list
		if (full_send_option_keys.includes(event_type)) {
			_addDaysOptions(days_before, $send_out_select);

			if (days_before_after) {
				$send_out_select.val(days_before_after);
			} else {
				$send_out_select.val(full_send_option[event_type]['day']);
			}

			$send_out_label.html(full_send_option[event_type]['label']);
		}

		$vendor_container.find('.eb-cruise-vendor-search').first().parent().addClass('hidden');
		$vendor_container.find('.eb-package-vendor-search').first().parent().addClass('hidden');
		$vendor_container.find('.eb-lodging-vendor-search').first().parent().addClass('hidden');

		// if this is a cruise, package, or lodging event, show the vendor selection
		if (cruise_event_types.includes(event_type)) {
			$dest_container.removeClass('hidden');
			$vendor_container.removeClass('hidden');
			$vendor_container.find('.eb-cruise-vendor-search').first().parent().removeClass('hidden');

			_addCruiseVendorOptions();
		} else if (package_event_types.includes(event_type)) {
			$vendor_container.removeClass('hidden');
			$vendor_container.find('.eb-package-vendor-search').first().parent().removeClass('hidden');

			_addPackageVendorOptions();
		} else if (lodging_event_types.includes(event_type)) {
			$vendor_container.removeClass('hidden');
			$vendor_container.find('.eb-lodging-vendor-search').first().parent().removeClass('hidden');

			_addLodgingVendorOptions();
		}

		if (reset_vendor) {
			$('.eb-reset-vendor').trigger('click');
		}
	}

	function _checkForDuplicateCta(action_id, $cta_container)
	{
		if (
			action_id !== 11 // cruise sheet
			&& action_id !== 12 // trip summary
			&& action_id !== 13 // vendor landing page
			&& action_id !== 16 // video library
			&& _ctaIsAlreadySelected(action_id)
		) {
			$cta_container.find('.eb-cta-dupe-alert').first().removeClass('hidden');
		}
	}

	async function _checkForDuplicateEcardSchedules(event_type)
	{
		if (!event_type) {
			return;
		}

		try {
			const response = await Adzuki.Ajax.get('/Ecards/getExistingSchedules/' + event_type);

			if (response.amount === 0) {
				return;
			}

			let confirm_text = 'The following eCard schedule(s) already exist for the "' + response.event_type + '" event type. Would you like to delete the eCard schedule(s) to prevent your client from receiving both types? <br><br><ul>';

			for (const schedule of response.schedules) {
				confirm_text += '<li>' + schedule.schedule_name + '</li>';
			}

			confirm_text += '</ul>';

			Adzuki.CustomConfirm({
				body   : confirm_text,
				confirm: function confirmRemoval() {
					const schedule_ids = response.schedules.map(schedule => schedule.id);

					Adzuki.Ajax.post('/Ecards/deleteSchedules', {
						schedule_ids: schedule_ids,
					});
				},
			});
		} catch (error) {
			return Adzuki.StatusMessage('error', error.message, 'Error!');
		}
	}

	function _ctaIsAlreadySelected(action_id)
	{
		var cta_selected_count = 0;

		$('.eb-cta-container').each(function onEachCta(i, elem) {
			var selected_action_id = $(elem).find('.cta-action-field').first().val();

			if (action_id === selected_action_id) {
				cta_selected_count++;
			}
		});

		return cta_selected_count > 1;
	}

	function _getNextCTAIndex()
	{
		var highest_index = 0;

		$('.eb-cta-container').each(function onEachCta(i, elem) {
			var cta_index = parseInt($(elem).data('index'));

			if (cta_index > highest_index) {
				highest_index = cta_index;
			}
		});

		return highest_index + 1;
	}

	function _getNextContentBlockIndex()
	{
		var highest_index = 0;

		$('.eb-cb-container').each(function onEachContentBlock(i, elem) {
			var block_index = parseInt($(elem).data('index'));

			if (block_index > highest_index) {
				highest_index = block_index;
			}
		});

		return highest_index + 1;
	}

	function _getNextContentImageBlockIndex()
	{
		var highest_index = 0;

		$('.eb-cib-container').each(function onEachContentImageBlock(i, elem) {
			var block_index = parseInt($(elem).data('index'));

			if (block_index > highest_index) {
				highest_index = block_index;
			}
		});

		return highest_index + 1;
	}

	function _getValidationErrorMessage(errors)
	{
		var error_string = '';

		if (typeof errors === 'string') {
			return Adzuki.Form.buildProcessingError(errors);
		}

		error_string += '<ul>';

		$.each(errors, function onEachErrorMsg(i, field_info) {
			if (field_info.error) {
				error_string += '<li>' + field_info.error + '</li>';
			}
		});

		error_string += '</ul>';

		return error_string;
	}

	function _highlightErrorFields(errors)
	{
		if (typeof errors === 'string') {
			return;
		}

		$.each(errors, function onEachErrorMsg(i, field_info) {
			if (field_info.field) {
				if (typeof field_info.field === 'string') {
					$('.' + field_info.field + '-field').addClass('has-error');
				} else {
					// using a jquery object
					field_info.field.parents('.form-group').addClass('has-error');
				}
			}
		});
	}

	function _initVendorTypeahead()
	{
		const $cruise_search  = $('#' + form_id + 'cruise_vendor_search');
		const $lodging_search = $('#' + form_id + 'lodging_vendor_search');
		const $package_search = $('#' + form_id + 'package_vendor_search');
		const $vendor_select  = $('#' + form_id + 'vendor_select');
		const $reset_vendor   = $('.eb-reset-vendor');

		// cruise vendor search typeahead
		Adzuki.Typeahead(
			$cruise_search,
			'/Vendors/searchVendorByType/cruise',
			function select(item, $self, typeahead) {
				$('#' + form_id + 'vendor_id').val(item.id);
				$cruise_search.prop('disabled', true);
				$reset_vendor.removeClass('hidden');
			}
		);

		// lodging vendor search typeahead
		Adzuki.Typeahead(
			$lodging_search,
			'/Vendors/searchVendorByType/lodging',
			function select(item, $self, typeahead) {
				$('#' + form_id + 'vendor_id').val(item.id);
				$lodging_search.prop('disabled', true);
				$reset_vendor.removeClass('hidden');
			}
		);

		// package vendor search typeahead
		Adzuki.Typeahead(
			$package_search,
			'/Vendors/searchVendorByType/package',
			function select(item, $self, typeahead) {
				$('#' + form_id + 'vendor_id').val(item.id);
				$package_search.prop('disabled', true);
				$reset_vendor.removeClass('hidden');
			}
		);

		// vendor select
		$vendor_select.off().on('change', function onVendorSelectChange(e) {
			const vendor_id = $(this).val();

			$('#' + form_id + 'vendor_id').val(vendor_id);
		});

		// vendor selection reset
		$reset_vendor.off().on('click', function onVendorSelectionReset(e) {
			e.preventDefault();

			$reset_vendor.addClass('hidden');

			$cruise_search.prop('disabled', false);
			$cruise_search.val('');
			$package_search.prop('disabled', false);
			$package_search.val('');
			$lodging_search.prop('disabled', false);
			$lodging_search.val('');

			$('#' + form_id + 'vendor_id').val('');
			$('.eb-vendor-search').removeClass('hidden');
			$('.eb-vendor-select').addClass('hidden');
		});

		// toggle to select vendor from typeahead search
		$('.eb-search-vendor').off().on('click', function onVendorSelectionSearch(e) {
			e.preventDefault();

			$reset_vendor.addClass('hidden');
			$vendor_select.val('');

			$cruise_search.prop('disabled', false);
			$cruise_search.val('');
			$package_search.prop('disabled', false);
			$package_search.val('');
			$lodging_search.prop('disabled', false);
			$lodging_search.val('');

			$('#' + form_id + 'vendor_id').val('');
			$('.eb-vendor-search').removeClass('hidden');
			$('.eb-vendor-select').addClass('hidden');
		});

		// toggle to select vendor from dropdown
		$('.eb-select-vendor').off().on('click', function onVendorSelectionSelect(e) {
			e.preventDefault();

			$vendor_select.val('');
			$reset_vendor.addClass('hidden');
			$('#' + form_id + 'vendor_id').val('');
			$('.eb-vendor-search').addClass('hidden');
			$('.eb-vendor-select').removeClass('hidden');
		});
	}

	function _reloadBannerOptions(banner_id)
	{
		var $banners_field = $('#' + form_id + 'email_builder_banner_id');

		$banners_field.empty();
		$banners_field.append(
			$('<option>').attr('value', '')
		);

		Adzuki.Ajax.get('/EmailBuilders/getBannersList')
		.then(function uploadCustomContent(response) {
			var banners = response;
			console.log(banners, 'reload response');
			$.each(banners, function onEachBanner(label, banner_options) {
				var $optgroup = $('<optgroup>').attr('label', label);

				$.each(banner_options, function onEachBannerOption(id, banner) {
					$optgroup.append(
						$('<option>').text(banner.text).attr({
							value     : id,
							'data-url': banner.url
						})
					);
				});

				$banners_field.append($optgroup);
			});

			// set the selected banner
			if (banner_id) {
				$banners_field.val(banner_id);

				$('.eb-preview-banner-btn').trigger('click');
			}
		});
	}

	function _reloadImageOptions(image_id, index, position)
	{
		var $images_field     = $('#' + form_id + 'content_image_blocks-' + index + '-email_builder_content_block_image_id');
		var $images_container = $images_field.parent();
		var url               = '/EmailBuilders/getImagesList';
		var vl_url            = 'visualList/image';

		if (position) {
			url += '/' + position;
			vl_url += '/' + position;

			// update visual list action url
			$images_container.find('.visual-list').first()
			.attr('data-action', vl_url)
			.data('action', vl_url);
		}

		$images_field.empty();
		$images_field.append(
			$('<option>').attr('value', '')
		);

		Adzuki.Ajax.get(url).then(function getImagesList(response) {
			var images = response;

			$.each(images, function onEachImage(label, image_options) {
				var $optgroup = $('<optgroup>').attr('label', label);

				$.each(image_options, function onEachImageOption(id, image) {
					$optgroup.append(
						$('<option>').text(image.text).attr({
							value     : id,
							'data-url': image.url
						})
					);
				});

				$images_field.append($optgroup);
			});

			// set the selected image
			if (image_id) {
				$images_field.val(image_id);
			}
		});
	}

	function _resetFieldsOnContentBlockContainer($cb_container)
	{
		var $content_fields     = $cb_container.find('.eb-cb-content-fields').first();
		var $content_checkbox   = $cb_container.find('.cb-element-type-field[value="content_block"]').first();
		var $content_text_field = $cb_container.find('.cb-content-field').first();
		var $offer_fields       = $cb_container.find('.eb-cb-offer-fields').first();
		var $offer_checkbox     = $cb_container.find('.cb-element-type-field[value="offer_block"]').first();
		var $cb_preview         = $cb_container.find('.eb-cb-preview').first();
		var $cb_edit            = $cb_container.find('.eb-cb-edit').first();

		// check the "Enter Content" checkbox
		$content_checkbox.prop('checked', true);
		$content_checkbox.parent().addClass('active');
		$offer_checkbox.prop('checked', false);
		$offer_checkbox.parent().removeClass('active');

		// reset the selected offer
		$cb_container.find('.cb-offers-field').first().val('');

		// set the size to "1 Column Wide"
		$cb_container.find('.cb-size-field').first().val('1-column');
		_updateResizeIcon($cb_container.find('.eb-resize-cb-btn').first(), 'close');

		// reset standalone status
		$cb_container.find('.cb-standalone-field').first().val('0');

		// reset the content text field value
		$content_text_field.val('');

		if (tinymce.get($content_text_field.attr('id'))) {
			tinymce.get($content_text_field.attr('id')).setContent('');
		}

		// remove any content
		$cb_container.find('.eb-cb-content').first().html('');

		// make sure we don't skip the content block
		$cb_container.find('.cb-skip-field').first().val('0');

		// display the form to edit the content block
		$cb_preview.addClass('hidden');
		$offer_fields.addClass('hidden');
		$cb_edit.removeClass('hidden');
		$content_fields.removeClass('hidden');
	}

	function _resetFieldsOnContentImageBlockContainer($cib_container)
	{
		var $content_fields     = $cib_container.find('.eb-cib-content-fields').first();
		var $content_text_field = $cib_container.find('.cib-content-field').first();
		var $offer_fields       = $cib_container.find('.eb-cib-offer-fields');
		var $cib_preview        = $cib_container.find('.eb-cib-preview').first();
		var $cib_edit           = $cib_container.find('.eb-cib-edit').first();

		// select the "Enter Content/Image" radio
		_selectContentImageBlockRadioOption($cib_container, 'content', false);

		// reset the selected offer
		$cib_container.find('.cib-offers-field').first().val('');

		// set the size to "1 Column Wide"
		$cib_container.find('.cib-size-field').first().val('1-column');
		_updateResizeIcon($cib_container.find('.eb-resize-cib-btn').first(), 'close');

		// reset standalone status
		$cib_container.find('.cib-standalone-field').first().val('0');

		// set the position to "Left"
		$cib_container.find('.cib-position-field').first().val('left');

		// reset the image field
		$cib_container.find('.cib-image-field').first().val('');

		// reset the content text field value
		$content_text_field.val('');

		if (tinymce.get($content_text_field.attr('id'))) {
			tinymce.get($content_text_field.attr('id')).setContent('');
		}

		// remove any content
		$cib_container.find('.eb-cib-content').first().html('');

		// make sure we don't skip the content image block
		$cib_container.find('.cib-skip-field').first().val('0');

		// clear any previously selected media hub image for this block
		$cib_container.find('.cib-image-media-id-field').first().val('');
		_resetMediaHubDragDrop($cib_container);

		// display the form to edit the content image block
		$cib_preview.addClass('hidden');
		$offer_fields.addClass('hidden');
		$cib_edit.removeClass('hidden');
		$content_fields.removeClass('hidden');
	}

	function _resetFieldsOnCtaContainer($cta_container, reset_action)
	{
		// reset action field?
		if (reset_action) {
			$cta_container.find('.cta-action-field').first().val('');
		}

		// hide drop downs
		$cta_container.find('.client-lead-form-field').first().addClass('hidden');
		$cta_container.find('.cruise-sheet-field').first().addClass('hidden');
		$cta_container.find('.trip-summary-field').first().addClass('hidden');
		$cta_container.find('.vendor-landing-field').first().addClass('hidden');
		$cta_container.find('.w2n-events-field').first().addClass('hidden');
		$cta_container.find('.video-field').first().addClass('hidden');
		$cta_container.find('.microsite-field').first().addClass('hidden');
		$cta_container.find('.link-url-field').first().addClass('hidden');

		// reset all drop down fields that require an entity (cruise sheet, w2n etc. etc.)
		$cta_container.find('.cta-cs-field').first().val('').removeAttr('update-text');
		$cta_container.find('.cta-ts-field').first().val('').removeAttr('update-text');
		$cta_container.find('.cta-vendor-page-field').first().val('');
		$cta_container.find('.cta-w2n-field').first().val('');
		$cta_container.find('.cta-video-field').first().val('');
		$cta_container.find('.cta-microsite-field').first().val('');

		// reset text value
		$cta_container.find('.cta-text-field').first().val('');

		// hide the duplicate CTA warning
		$cta_container.find('.eb-cta-dupe-alert').first().addClass('hidden');

		// make sure we don't skip the cta
		$cta_container.find('.cta-skip-field').first().val('0');
	}

	function _resizeContentBlock($resize_btn)
	{
		var $row                      = $resize_btn.parents('.eb-cb-row').first();
		var cb_length                 = $row.find('.eb-cb-container').length;
		var $cur_cb_container         = null;
		var $cur_cb_sibling           = null;
		var $new_cb_row               = null;
		var $new_insert_cb_button_row = null;

		if (cb_length === 1) {
			// there is only one content block on the row
			$cur_cb_container = $row.find('.eb-cb-container').first();

			// this content block has a full-size width, resize to half-width
			if ($cur_cb_container.hasClass('col-sm-12')) {
				$cur_cb_container.removeClass('col-sm-12 col-sm-6').addClass('col-sm-6');
				$cur_cb_container.find('.cb-size-field').first().val('1-column');

				// this content block takes half-width and it's on it's own row, set standalone flag
				$cur_cb_container.find('.cb-standalone-field').first().val('1');

				_updateResizeIcon($resize_btn, 'open');
			} else {
				// content block is half-width, resize to full-size width
				$cur_cb_container.removeClass('col-sm-12 col-sm-6').addClass('col-sm-12');
				$cur_cb_container.find('.cb-size-field').first().val('2-columns');

				// reset standalone status, since it takes the whole row
				$cur_cb_container.find('.cb-standalone-field').first().val('0');

				_updateResizeIcon($resize_btn, 'close');
			}
		} else {
			// there are 2(two!) half-width blocks on this row
			$cur_cb_container = $resize_btn.parents('.eb-cb-container').first();
			$cur_cb_sibling   = $cur_cb_container.siblings('.eb-cb-container').first();

			// create a new row below for the sibling
			$new_cb_row = $('<div class="eb-cb-row row margin20-top"></div>');
			$new_cb_row.insertAfter($resize_btn.parents('.eb-cb-row').next('.eb-insert-cb-row'));

			// move the sibling to this new row, set to full-width and update it's resize icon
			$cur_cb_sibling.removeClass('col-sm-12 col-sm-6').addClass('col-sm-12');
			$cur_cb_sibling.find('.cb-size-field').first().val('2-columns');
			$cur_cb_sibling.find('.cb-standalone-field').first().val('0');
			_updateResizeIcon($cur_cb_sibling.find('.eb-resize-cb-btn').first(), 'close');

			$new_cb_row.append($cur_cb_sibling);

			// reset and re-init the editor, since we moved it somewhere else in the DOM
			$cur_cb_sibling.find('.cb-content-field').first().next('.tox-tinymce').remove();

			Adzuki.Editor('#' + form_id + 'content_blocks-' + $cur_cb_sibling.data('index') + '-content', {
				editor_type: editor_type,
			});

			// create the button to add a new content block below this new row
			$new_insert_cb_button_row = $('.eb-insert-cb-row').first().clone(false);
			$new_insert_cb_button_row.insertAfter($new_cb_row);

			// resize the target content block to full-width and update resize icon
			$cur_cb_container.removeClass('col-sm-12 col-sm-6').addClass('col-sm-12');
			$cur_cb_container.find('.cb-size-field').first().val('2-columns');
			$cur_cb_container.find('.cb-standalone-field').first().val('0');
			_updateResizeIcon($cur_cb_container.find('.eb-resize-cb-btn').first(), 'close');

			// finally add event listeners for the "Insert New Content Block" for this row
			_addClickHandlersToInsertContentBlocks();
		}

		_updateContentBlockOrdering();
	}

	function _resizeOfferContentImageBlock($resize_btn)
	{
		var $row                       = $resize_btn.parents('.eb-cib-row').first();
		var cib_length                 = $row.find('.eb-cib-container').length;
		var $cur_cib_container         = $resize_btn.parents('.eb-cib-container').first();
		var $cur_cib_sibling           = null;
		var $new_cib_row               = null;
		var $new_insert_cib_button_row = null;

		if (cib_length === 1) {
			// there is only one offer on the row
			$cur_cib_container = $row.find('.eb-cib-container').first();

			// this offer has a full-size width, resize to half-width
			if ($cur_cib_container.hasClass('col-sm-12')) {
				$cur_cib_container.removeClass('col-sm-12 col-sm-6').addClass('col-sm-6');
				$cur_cib_container.find('.cib-size-field').first().val('1-column');

				// this offer now takes half-width and it's on it's own row, set standalone flag
				$cur_cib_container.find('.cib-standalone-field').first().val('1');

				_updateResizeIcon($resize_btn, 'open');
				_updateContentImageBlockRadio($cur_cib_container, 'disabled');
			} else {
				// offer is half-width, resize to full-size width
				$cur_cib_container.removeClass('col-sm-12 col-sm-6').addClass('col-sm-12');
				$cur_cib_container.find('.cib-size-field').first().val('2-columns');

				// reset standalone status, since it takes the whole row
				$cur_cib_container.find('.cib-standalone-field').first().val('0');

				_updateResizeIcon($resize_btn, 'close');
				_updateContentImageBlockRadio($cur_cib_container, 'enabled');
			}
		} else {
			// there are 2(two!) half-width offer blocks on this row
			$cur_cib_container = $resize_btn.parents('.eb-cib-container').first();
			$cur_cib_sibling   = $cur_cib_container.siblings('.eb-cib-container').first();

			// create a new row below for the sibling
			$new_cib_row = $('<div class="eb-cib-row row margin20-top"></div>');
			$new_cib_row.insertAfter($resize_btn.parents('.eb-cib-row').next('.eb-insert-cib-row'));

			// set sibling offer to full-width and update it's resize icon
			$cur_cib_sibling.removeClass('col-sm-12 col-sm-6').addClass('col-sm-12');
			$cur_cib_sibling.find('.cib-size-field').first().val('2-columns');
			$cur_cib_sibling.find('.cib-standalone-field').first().val('0');
			_updateResizeIcon($cur_cib_sibling.find('.eb-resize-cib-btn').first(), 'close');
			_updateContentImageBlockRadio($cur_cib_sibling, 'enabled');

			// move this sibling offer to the new row
			$new_cib_row.append($cur_cib_sibling);

			// reset and re-init the editor, since we moved it somewhere else in the DOM
			$cur_cib_sibling.find('.cib-content-field').first().next('.tox-tinymce').remove();

			Adzuki.Editor('#' + form_id + 'content_image_blocks-' + $cur_cib_sibling.data('index') + '-content', {
				editor_type: editor_type,
			});

			// create the button to add a new content image block below this new row
			$new_insert_cib_button_row = $('.eb-insert-cib-row').first().clone(false);
			$new_insert_cib_button_row.insertAfter($new_cib_row);

			// resize the target offer to full-width and update resize icon
			$cur_cib_container.removeClass('col-sm-12 col-sm-6').addClass('col-sm-12');
			$cur_cib_container.find('.cib-size-field').first().val('2-columns');
			$cur_cib_container.find('.cib-standalone-field').first().val('0');
			_updateResizeIcon($cur_cib_container.find('.eb-resize-cib-btn').first(), 'close');
			_updateContentImageBlockRadio($cur_cib_container, 'enabled');

			// finally add event listeners for the "Insert New Content/Image Block" for this row
			_addClickHandlersToInsertContentImageBlocks();
		}

		_updateContentImageBlockOrdering();
	}

	function _schedulerEventTypes(schedule_days)
	{
		const $event_type_select         = $('#' + form_id + 'event_type_key');
		const $send_out_select           = $('#' + form_id + 'send_days_before_after');
		const $send_out_label            = $('.eb-send-out-label');
		const full_send_option_keys      = Object.keys(full_send_option);
		const seven_day_send_option_keys = Object.keys(seven_day_send_option);

		// changing the event type for the schedule
		$event_type_select.on('change', function onEventTypeKeyChange(e, new_schedule) {
			const event_type = $(this).val();

			_changeEventType(event_type, schedule_days, null, true);

			if (!new_schedule) {
				_checkForDuplicateEcardSchedules(event_type);
			}
		});

		// changing the send out day for the schedule
		$send_out_select.on('change', function onSendOutDayChange(e) {
			const current_day = $(this).val();
			const event_type  = $event_type_select.val();
			let label         = '';

			if (seven_day_send_option[event_type] !== undefined) {
				label = seven_day_send_option[event_type]['label'];
			} else if (full_send_option[event_type] !== undefined) {
				label = full_send_option[event_type]['label'];
			}

			if (parseInt(current_day) === 0) {
				$send_out_label.html(label);
			} else if (seven_day_send_option_keys.includes(event_type)) {
				$send_out_label.html('after ' + label);
			} else if (full_send_option_keys.includes(event_type)) {
				$send_out_label.html(label);
			}
		});

		// trigger only when creating a new schedule
		const schedule_id = $('#' + form_id + 'id').val();

		if (schedule_id) {
			const vendor_id         = $('#' + form_id + 'vendor_id').val();
			const event_type        = $event_type_select.val();
			const days_before_after = $send_out_select.val();
			let reset_vendor        = false;

			if (vendor_id) {
				reset_vendor = true;
			}

			_changeEventType(event_type, schedule_days, days_before_after, reset_vendor);
			_checkForDuplicateEcardSchedules(event_type);

			$send_out_select.trigger('change');
		} else {
			$event_type_select.trigger('change', [true]);
			$send_out_select.trigger('change');
		}

		_initVendorTypeahead();
	}

	function _selectContentImageBlockRadioOption($cib_container, type, trigger_change_event)
	{
		var $content_radio = $cib_container.find('.cib-element-type-field[value="content_image_block"]').first();
		var $offer_radio   = $cib_container.find('.cib-element-type-field[value="offer_block"]').first();

		// select the "Select Offer" radio option
		if (type === 'offer') {
			$offer_radio.prop('checked', true);
			$offer_radio.parent().addClass('active');
			$content_radio.prop('checked', false);
			$content_radio.parent().removeClass('active');
		} else {
			// select the "Enter Content/Image" radio
			$content_radio.prop('checked', true);
			$content_radio.parent().addClass('active');
			$offer_radio.prop('checked', false);
			$offer_radio.parent().removeClass('active');
		}

		if (trigger_change_event) {
			$cib_container.find('.cib-element-type-field:checked').trigger('change');
		}
	}

	function _setLayout(layout_id)
	{
		var $templates_field = $('#' + form_id + 'template_id');
		var $content_block    = null;

		// pre-populate available templates based on the selected layout
		if ($templates_field.length > 0) {

			$templates_field.empty();
			$templates_field.append(
				$('<option>').attr('value', '')
			);

			Adzuki.Ajax.get('/EmailBuilders/getAllTemplatesList/' + layout_id)
			.then(function getAllTemplatesList(response) {
				var templates = response;

				$.each(templates, function onEachTemplate(label, template_opts) {
					var $optgroup = $('<optgroup>').attr('label', label);

					$.each(template_opts, function onEachTemplateOption(id, template_name) {
						$optgroup.append(
							$('<option>').text(template_name).attr({
								value: id,
							})
						);
					});

					$templates_field.append($optgroup);
				});
			});
		}

		// switching from layout 2: remove content blocks
		if (prev_layout_id === 2) {
			// remove content blocks
			$('.eb-cb-container').each(function onEachCbContainer(i, elem) {
				var $cb_container = $(elem);

				$cb_container.find('.eb-remove-cb-btn').first().trigger('click');
			});

			// hide the button to add the first content block
			$('.eb-insert-cb-row').addClass('hidden');
		}

		// switching from layout 3: remove content image blocks
		if (prev_layout_id === 3) {
			// remove content image blocks
			$('.eb-cib-container').each(function onEachCibContainer(i, elem) {
				var $cib_container = $(elem);

				$cib_container.find('.eb-remove-cib-btn').first().trigger('click');
			});

			// hide the button to add the first content image block
			$('.eb-insert-cib-row').addClass('hidden');
		}

		// switching to layout 2: add default content block
		if (layout_id === 2) {
			// display the button to add the first content block and trigger click
			$('.eb-insert-cb-row').removeClass('hidden');
			$('.eb-insert-cb-row').find('.eb-insert-cb').first().trigger('click');

			// set the content block to edit mode
			$content_block = $('.eb-cb-container').first();
			$content_block.find('.eb-edit-cb-btn').first().trigger('click');
		}

		// switching to layout 3: add default content image block
		if (layout_id === 3) {
			// display the button to add the first content image block and trigger click
			$('.eb-insert-cib-row').removeClass('hidden');
			$('.eb-insert-cib-row').find('.eb-insert-cib').first().trigger('click');

			// set the content image block to edit mode
			$content_block = $('.eb-cib-container').first();
			$content_block.find('.eb-edit-cib-btn').first().trigger('click');
		}
	}

	/**
	 * Rebuilds the "Previous Attachments" list from attachments belonging to a template.
	 * The rows are cloned from the prototype markup so they match what the server renders.
	 */
	function _setPreviousAttachments(attachments)
	{
		var $container = $('#previous_attachments');
		var $source    = $('#' + form_id + 'previous_attachments-source');
		var $prototype = null;
		var $list      = null;

		if ($container.length === 0) {
			return;
		}

		$list      = $container.find('.current_attachments').first();
		$prototype = $container.find('.attachment-prototype').first();

		$list.empty();

		if (!attachments || attachments.length === 0) {
			$source.val('');
			$container.addClass('hidden');

			return;
		}

		$.each(attachments, function onEachTemplateAttachment(i, attachment) {
			var $row = $prototype.clone();

			$row.removeClass('attachment-prototype hidden');
			$row.find('.attachment-filename').text(attachment.display_name);
			$row.find('.attachment-filesize').text(attachment.display_size);
			$row.find('input').prop('disabled', false).val(attachment.id);

			$list.append($row);
		});

		// the ids belong to the template's attachment table, not the email's
		$source.val('template');
		$container.removeClass('hidden');
	}

	function _setTemplate(template_id)
	{
		var $prev_cib      = null;
		var prev_cib_entry = null;

		Adzuki.Ajax.get('/EmailBuilders/getTemplateDetails/' + template_id)
		.then(function getTemplateDetails(response) {
			var template  = response;
			var layout_id = 1;

			if (response.error) {
				Adzuki.StatusMessage('error', response.error);
				return;
			}

			layout_id = parseInt(template.email_builder_layout_id);

			// set the "from" address
			$('#' + form_id + 'from').val(template.from);

			// set the subject
			$('#' + form_id + 'subject').val(template.subject);

			// set the banner
			$('#' + form_id + 'email_builder_banner_id').val(template.email_builder_banner_id);
			$('.eb-preview-banner-btn').trigger('click');

			// set the email message
			if (message_editor) {
				message_editor.setContent(template.message);

				$('#' + form_id + 'message').val(template.message);
				$('.eb-preview-message-btn').trigger('click');
			}

			// carry the template's attachments over to the email
			_setPreviousAttachments(template.attachments);

			// remove any existing ctas
			$('.eb-cta-container').each(function onEachCtaContainer(i, elem) {
				var $cta_container = $(elem);

				$cta_container.find('.eb-remove-cta-btn').first().trigger('click');
			});

			// add the ctas from the template (if any)
			if (template.ctas && template.ctas.length > 0) {
				$.each(template.ctas, function onEachCta(i, cta) {
					var $cta_container = null;

					// click the button to add the cta
					$('.eb-cta-container').last().find('.eb-insert-cta').first().trigger('click');

					// set the values on this new cta
					$cta_container = $('.eb-cta-container').last();

					// set the action
					$cta_container.find('.cta-action-field').first().val(cta.email_builder_cta_element_action_type_id);

					// set the text
					$cta_container.find('.cta-text-field').first().val(cta.link_text);

					// make appropriate selections based on the CTA action type
					switch (cta.action) {
						case 'where2next-event':
							// display and select the where2next event
							$cta_container.find('.w2n-events-field').first().removeClass('hidden');
							$cta_container.find('.cta-w2n-field').first().val(cta.entity_id);
							break;
						case 'cruise-sheet':
							// display and select the cruise sheet
							$cta_container.find('.cruise-sheet-field').first().removeClass('hidden');
							$cta_container.find('.cta-cs-field').first().val(cta.entity_id)
							.attr('update-text', '0');
							break;
						case 'trip-summary':
							// display and select the trip summary
							$cta_container.find('.trip-summary-field').first().removeClass('hidden');
							$cta_container.find('.cta-ts-field').first().val(cta.entity_id)
							.attr('update-text', '0');
							break;
						case 'vendor-landing-page':
							// display and select the vendor landing page
							$cta_container.find('.vendor-landing-field').first().removeClass('hidden');
							$cta_container.find('.cta-vendor-page-field').first().val(cta.entity_id);
							break;
						case 'client-lead-form':
							// display and select the client lead form
							$cta_container.find('.client-lead-form-field').first().removeClass('hidden');
							$cta_container.find('.cta-client-form-field').first().val(cta.entity_id);
							break;
					case 'video-library':
						// display and select the video
						$cta_container.find('.video-field').first().removeClass('hidden');
						$cta_container.find('.cta-video-field').first().val(cta.entity_id);
						break;
					case 'microsite':
						// display and select the signature microsite
						$cta_container.find('.microsite-field').first().removeClass('hidden');
						$cta_container.find('.cta-microsite-field').first().val(cta.entity_id);
						break;
					case 'testimonial':
					case 'custom-cta':
						// display field to enter an url
						$cta_container.find('.link-url-field').first().removeClass('hidden');

						// if link url was provided, prepopulate the field
						if (cta.link_url) {
							$cta_container.find('.cta-link-url-field').first().val(cta.link_url);
						}
						break;
					default:
						// nothing to do
				}

					// set the text color
					$cta_container.find('.cta-text-color-field').first()
					.spectrum('set', cta.text_color);

					// set the border color
					$cta_container.find('.cta-border-color-field').first()
					.spectrum('set', cta.border_color);

					// preview the newly added cta
					$cta_container.find('.eb-preview-cta-btn').first().trigger('click');
				});
			}

			// remove any existing content blocks
			$('.eb-cb-container').each(function onEachCbContainer(i, elem) {
				var $cb_container = $(elem);

				$cb_container.find('.eb-remove-cb-btn').first().trigger('click');
			});

			// add the content blocks from the template (if any)
			if (layout_id === 2 && template.content_blocks && template.content_blocks.length > 0) {
				$.each(template.content_blocks, function onEachContentBlock(i, cb) {
					var $cb_container  = null;
					var $content_field = null;

					// click the button to add the content block
					$('.eb-insert-cb-row').last().find('.eb-insert-cb').first().trigger('click');

					// set the values on this new content block
					$cb_container = $('.eb-cb-row').last().find('.eb-cb-container').last();

					// set content block type (content or offer)
					$cb_container.find('.cb-element-type-field').prop('checked', false);

					if (cb.offer_id) {
						$cb_container.find('.cb-element-type-field[value="offer_block"]')
						.first().prop('checked', true);
					} else {
						$cb_container.find('.cb-element-type-field[value="content_block"]')
						.first().prop('checked', true);
					}

					$cb_container.find('.cb-element-type-field:checked').trigger('change');

					// set column size
					$cb_container.find('.cb-size-field').first().val(cb.content_block_size);

					// set standalone status
					$cb_container.find('.cb-standalone-field').first().val(cb.standalone);

					// if this is an offer block, set the offer id
					// otherwise just set the content on the editor
					if (cb.offer_id) {
						$cb_container.find('.cb-offers-field').first().val(cb.offer_id);
					} else {
						$content_field = $cb_container.find('.cb-content-field').first();

						$content_field.val(cb.content);
						tinymce.get($content_field.attr('id')).setContent(cb.content);
					}

					// preview the newly added content block
					$cb_container.find('.eb-preview-cb-btn').first().trigger('click');
				});
			}

			// remove any existing content image blocks
			$('.eb-cib-container').each(function onEachCibContainer(i, elem) {
				var $cib_container = $(elem);

				$cib_container.find('.eb-remove-cib-btn').first().trigger('click');
			});

			// add the content image blocks from the template (if any)
			if (layout_id === 3 && template.content_image_blocks && template.content_image_blocks.length > 0) {
				$.each(template.content_image_blocks, function onEachContentImageBlock(i, cib) {
					var $cib_container = null;
					var $content_field = null;

					// keep track of the previous content image block
					if (i > 0) {
						prev_cib_entry = template.content_image_blocks[i-1];
						$prev_cib      = $('.eb-cib-container').last();
					}

					// click the button to add the content image block
					$('.eb-insert-cib-row').last().find('.eb-insert-cib').first().trigger('click');

					// set the values on this new content image block
					$cib_container = $('.eb-cib-row').last().find('.eb-cib-container').last();

					// set content block type (content or offer)
					$cib_container.find('.cib-element-type-field')
					.prop('checked', false).parent().removeClass('active');

					if (cib.offer_id) {
						// this is an offer block, set the appropriate values
						$cib_container.find('.cib-element-type-field[value="offer_block"]')
						.first().prop('checked', true)
						.parent().addClass('active');

						$cib_container.find('.cib-element-type-field:checked').trigger('change');

						// set column size
						$cib_container.find('.cib-size-field').first().val(cib.content_block_size);

						// set offer
						$cib_container.find('.cib-offers-field').first().val(cib.offer_id);

						// set standalone status
						$cib_container.find('.cib-standalone-field').first().val(cib.standalone);
					} else {
						// this is regular content image block, set the appropriate values
						$cib_container.find('.cib-element-type-field[value="content_image_block"]')
						.first().prop('checked', true)
						.parent().addClass('active');

						$cib_container.find('.cib-element-type-field:checked').trigger('change');

						// set the position of the content image block
						$cib_container.find('.cib-position-field').first().val(cib.content_block_image_position);

						// set the image of the content image block
						$cib_container.find('.cib-image-field').first().val(cib.email_builder_content_block_image_id);

						// set the content of the editor
						$content_field = $cib_container.find('.cib-content-field').first();
						$content_field.val(cib.content);
						tinymce.get($content_field.attr('id')).setContent(cib.content);
					}

					// if the previous block is an offer block with a width of 2(two!) columns
					// or an offer block that is on it's own row
					// then we must resize it accordingly
					if (
						prev_cib_entry
						&& prev_cib_entry.offer_id
						&& (
							prev_cib_entry.content_block_size === '2-columns' ||
							parseInt(prev_cib_entry.standalone) === 1
						)
					) {
						// resize the previous block
						_resizeOfferContentImageBlock($prev_cib.find('.eb-resize-cib-btn').first());

						// the previous block is a standalone offer block, resize it again in place
						if (parseInt(prev_cib_entry.standalone) === 1) {
							_resizeOfferContentImageBlock($prev_cib.find('.eb-resize-cib-btn').first());
						}
					}

					// preview the newly added content image block
					$cib_container.find('.eb-preview-cib-btn').first().trigger('click');
				});
			}
		}).catch(function onError(error) {
			Adzuki.StatusMessage('error', error);
		});
	}

	function _updateContentBlockOrdering()
	{
		$('.eb-cb-container').each(function onEachCbContainer(i, elem) {
			var $cb_container = $(elem);

			$cb_container.find('.cb-order-field').first().val(i+1);
		});
	}

	function _updateContentImageBlockOrdering()
	{
		$('.eb-cib-container').each(function onEachCibContainer(i, elem) {
			var $cib_container = $(elem);

			$cib_container.find('.cib-order-field').first().val(i+1);
		});
	}

	function _updateContentImageBlockRadio($cib_container, state)
	{
		var $radio = $cib_container.find('.cib-element-type-field[value="content_image_block"]').first();

		if (state === 'disabled') {
			$radio.prop('disabled', true);
			$radio.parent().addClass('disabled');
			return;
		}

		$radio.prop('disabled', false);
		$radio.parent().removeClass('disabled');
	}

	function _updateCtaAttributesFromTemplate(template_id)
	{
		Adzuki.Ajax.get('/EmailBuilders/getTemplateDetails/' + template_id)
		.then(function _getTemplateDetails(response) {
			var template = response;

			if (response.error) {
				return;
			}

			if (template.ctas && template.ctas.length > 0) {
				$.each(template.ctas, function _onEachCta(i, cta) {
					var $cta_container = $('.eb-cta-container[data-index="' + i + '"').first();

					switch (cta.action) {
						case 'cruise-sheet':
							// set attr on cs field
							$cta_container.find('.cta-cs-field').first()
							.attr('update-text', '0');
							break;
						case 'trip-summary':
							// set attr on ts field
							$cta_container.find('.cta-ts-field').first()
							.attr('update-text', '0');
							break;
						default:
							// nothing to do
					}
				});
			}
		});
	}

	function _updateCtaOrdering()
	{
		$('.eb-cta-container').each(function onEachCtaContainer(i, elem) {
			var $cta_container = $(elem);

			$cta_container.find('.cta-order-field').first().val(i+1);
		});
	}

	function _updateCtaPreview($cta_container, cta_data)
	{
		var text         = cta_data.text;
		var text_color   = cta_data.text_color;
		var border_color = cta_data.border_color;

		Adzuki.Ajax.post('/EmailBuilders/getCtaLinkAndIcon', { cta: cta_data })
		.then(function getCtaLink(response) {
			var link       = response.link;
			var action     = response.action;
			var icon_url   = response.icon;
			var icon_width = $cta_container.find('cta-icon-link img').first().attr('width');

			// use a bigger width for vendor landing pages
			if (action === 'vendor-landing-page') {
				icon_width = 100;
			}

			// update cta icon link
			$cta_container.find('.cta-icon-link').first().attr('href', link);

			// update cta icon image
			$cta_container.find('.cta-icon-link img').first()
			.attr({
				src  : icon_url,
				width: icon_width,
			});

			// update cta text, text link and text color
			$cta_container.find('.cta-content-text a').first().text(text).attr({
				href : link,
				style: 'text-decoration: none; color: ' + text_color + ';',
			});

			// update cta border color
			$cta_container.find('.eb-cta-item-container').attr('style', 'border-color: ' + border_color + ';');
		});
	}

	function _updateCtaTextDescription($cta_container, entity_id)
	{
		var action_id = $cta_container.find('.cta-action-field').first().val();

		// nothing selected
		if (!entity_id) {
			return;
		}

		Adzuki.Ajax.get('/EmailBuilders/getCtaTextDescription/' + action_id + '/' + entity_id)
		.then(function getCtaActionDescription(response) {
			var action_description = response.text;

			$cta_container.find('.cta-text-field').first()
			.val(action_description).trigger('input');
		});
	}

	function _updateIndexOnContentBlockContainer($cb_container, index)
	{
		$cb_container.attr('data-index', index);
		$cb_container.data('index', index);

		// update sort order field
		$cb_container.find('.cb-order-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_blocks][' + index + '][sort_order]')
		.attr('id', form_id + 'content_blocks-' + index + '-sort_order');

		// update skip field
		$cb_container.find('.cb-skip-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_blocks][' + index + '][skip]')
		.attr('id', form_id + 'content_blocks-' + index + '-skip');

		// update standalone field
		$cb_container.find('.cb-standalone-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_blocks][' + index + '][standalone]')
		.attr('id', form_id + 'content_blocks-' + index + '-standalone');

		// update content type fields
		$cb_container.find('.cb-element-type-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_blocks][' + index + '][element_type]')
		.attr('id', form_id + 'content_blocks-' + index + '-element-type-0');

		$cb_container.find('.cb-element-type-field').last()
		.attr('name', 'form_component_data[EmailBuilder][content_blocks][' + index + '][element_type]')
		.attr('id', form_id + 'content_blocks-' + index + '-element-type-1');

		// update size field
		$cb_container.find('.cb-size-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_blocks][' + index + '][content_block_size]')
		.attr('id', form_id + 'content_blocks-' + index + '-content_block_size');

		// update the content textarea
		$cb_container.find('.cb-content-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_blocks][' + index + '][content]')
		.attr('id', form_id + 'content_blocks-' + index + '-content')
		.attr('style', '');

		// remove the markup from the tinymce editor, we'll re-initialize it again
		$cb_container.find('.cb-content-field').first().next('.tox-tinymce').remove();

		// update dropdown to select an offer
		$cb_container.find('.cb-offers-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_blocks][' + index + '][offer_id]')
		.attr('id', form_id + 'content_blocks-' + index + '-offer_id');

		// update id on the button to resize the content block and it's container
		$cb_container.find('.eb-resize-cb-btn').first()
		.attr('href', '#cb-resize-' + index);

		$cb_container.find('.eb-cb-resize-info').first()
		.attr('id', 'cb-resize-' + index);
	}

	function _updateIndexOnContentImageBlockContainer($cib_container, index)
	{
		$cib_container.attr('data-index', index);
		$cib_container.data('index', index);

		// update sort order field
		$cib_container.find('.cib-order-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_image_blocks][' + index + '][sort_order]')
		.attr('id', form_id + 'content_image_blocks-' + index + '-sort_order');

		// update skip field
		$cib_container.find('.cib-skip-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_image_blocks][' + index + '][skip]')
		.attr('id', form_id + 'content_image_blocks-' + index + '-skip');

		// update standalone field
		$cib_container.find('.cib-standalone-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_image_blocks][' + index + '][standalone]')
		.attr('id', form_id + 'content_image_blocks-' + index + '-standalone');

		// update content type fields
		$cib_container.find('.cib-element-type-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_image_blocks][' + index + '][element_type]')
		.attr('id', form_id + 'content_image_blocks-' + index + '-element-type-0');

		$cib_container.find('.cib-element-type-field').last()
		.attr('name', 'form_component_data[EmailBuilder][content_image_blocks][' + index + '][element_type]')
		.attr('id', form_id + 'content_image_blocks-' + index + '-element-type-1');

		// update size field
		$cib_container.find('.cib-size-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_image_blocks][' + index + '][content_block_size]')
		.attr('id', form_id + 'content_image_blocks-' + index + '-content_block_size');

		// update id on the button to resize the content block and it's container
		$cib_container.find('.eb-resize-cib-btn').first()
		.attr('href', '#cib-resize-' + index);

		$cib_container.find('.eb-cib-resize-info').first()
		.attr('id', 'cib-resize-' + index);

		// update dropdown to select an offer
		$cib_container.find('.cib-offers-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_image_blocks][' + index + '][offer_id]')
		.attr('id', form_id + 'content_image_blocks-' + index + '-offer_id');

		// update the position field
		$cib_container.find('.cib-position-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_image_blocks][' + index + '][content_block_image_position]')
		.attr('id', form_id + 'content_image_blocks-' + index + '-content_block_image_position');

		// update the image field
		$cib_container.find('.cib-image-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_image_blocks][' + index + '][email_builder_content_block_image_id]')
		.attr('id', form_id + 'content_image_blocks-' + index + '-email_builder_content_block_image_id');

		// update the content textarea
		$cib_container.find('.cib-content-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_image_blocks][' + index + '][content]')
		.attr('id', form_id + 'content_image_blocks-' + index + '-content')
		.attr('style', '');

		// remove the markup from the tinymce editor, we'll re-initialize it again
		$cib_container.find('.cib-content-field').first().next('.tox-tinymce').remove();

		// update the image position (upload custom content)
		$cib_container.find('.cib-image-position-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_image_blocks][' + index + '][image_position]')
		.attr('id', form_id + 'content_image_blocks-' + index + '-image_position');

		// update the image name (upload custom content)
		$cib_container.find('.cib-image-name-field').first()
		.attr('name', 'form_component_data[EmailBuilder][content_image_blocks][' + index + '][image_name]')
		.attr('id', form_id + 'content_image_blocks-' + index + '-image_name');

		// update select id on the visual list
		$cib_container.find('.visual-list').first().attr('data-select-box', form_id + 'content_image_blocks-' + index + '-email_builder_content_block_image_id')
		.data('select-box', form_id + 'content_image_blocks-' + index + '-email_builder_content_block_image_id');

		// per-CIB media hub target input
		_resetMediaHubDragDrop($cib_container);
		$cib_container.find('.cib-image-media-id-field').first()
		.attr('id', form_id + 'content_image_blocks-' + index + '-image_media_id')
		.attr('data-bind-key', 'cib_image_' + index)
		.val('');

		_replaceMediaHubFromPrototype(
			$cib_container.find('.eb-cib-upload').first(),
			'#eb-cib-mediahub-prototype',
			'cib_image_' + index
		);
	}

	function _updateIndexOnCtaContainer($cta_container, index)
	{
		$cta_container.attr('data-index', index);

		// update sort order field
		$cta_container.find('.cta-order-field').first()
		.attr('name', 'form_component_data[EmailBuilder][ctas][' + index + '][sort_order]')
		.attr('id', form_id + 'ctas-' + index + '-sort_order');

		// update skip field
		$cta_container.find('.cta-skip-field').first()
		.attr('name', 'form_component_data[EmailBuilder][ctas][' + index + '][skip]')
		.attr('id', form_id + 'ctas-' + index + '-skip');

		// update action field
		$cta_container.find('.cta-action-field').first()
		.attr('name', 'form_component_data[EmailBuilder][ctas][' + index + '][action_id]')
		.attr('id', form_id + 'ctas-' + index + '-action_id');

		// update text field
		$cta_container.find('.cta-text-field').first()
		.attr('name', 'form_component_data[EmailBuilder][ctas][' + index + '][text]')
		.attr('id', form_id + 'ctas-' + index + '-text');

		// update link url field
		$cta_container.find('.cta-link-url-field').first()
		.attr('name', 'form_component_data[EmailBuilder][ctas][' + index + '][link_url]')
		.attr('id', form_id + 'ctas-' + index + '-link_url');

		// update client lead form id field
		$cta_container.find('.cta-client-form-field').first()
		.attr('name', 'form_component_data[EmailBuilder][ctas][' + index + '][client_lead_form_id]')
		.attr('id', form_id + 'ctas-' + index + '-client_lead_form_id');

		// update cruise sheet id field
		$cta_container.find('.cta-cs-field').first()
		.attr('name', 'form_component_data[EmailBuilder][ctas][' + index + '][cruise_sheet_id]')
		.attr('id', form_id + 'ctas-' + index + '-cruise_sheet_id');

		// update trip summary id field
		$cta_container.find('.cta-ts-field').first()
		.attr('name', 'form_component_data[EmailBuilder][ctas][' + index + '][trip_summary_id]')
		.attr('id', form_id + 'ctas-' + index + '-trip_summary_id');

		// update vendor landing page id field
		$cta_container.find('.cta-vendor-page-field').first()
		.attr('name', 'form_component_data[EmailBuilder][ctas][' + index + '][vendor_landing_page_id]')
		.attr('id', form_id + 'ctas-' + index + '-vendor_landing_page_id');

		// update virtual event id field
		$cta_container.find('.cta-w2n-field').first()
		.attr('name', 'form_component_data[EmailBuilder][ctas][' + index + '][virtual_event_id]')
		.attr('id', form_id + 'ctas-' + index + '-virtual_event_id');

		// update video id field
		$cta_container.find('.cta-video-field').first()
		.attr('name', 'form_component_data[EmailBuilder][ctas][' + index + '][video_id]')
		.attr('id', form_id + 'ctas-' + index + '-video_id')
		.attr('data-bind-key', 'cta_video_' + index)
		.val('');

		_replaceMediaHubFromPrototype(
			$cta_container.find('.video-field').first(),
			'#eb-cta-video-mediahub-prototype',
			'cta_video_' + index
		);

		// update signature microsite id field
		$cta_container.find('.cta-microsite-field').first()
		.attr('name', 'form_component_data[EmailBuilder][ctas][' + index + '][microsite_id]')
		.attr('id', form_id + 'ctas-' + index + '-microsite_id');

		// update text color field
		$cta_container.find('.cta-text-color-field').first()
		.attr('name', 'form_component_data[EmailBuilder][ctas][' + index + '][text_color]')
		.attr('id', form_id + 'ctas-' + index + '-text_color')
		.next('.sp-replacer').remove();

		// update border color field
		$cta_container.find('.cta-border-color-field').first()
		.attr('name', 'form_component_data[EmailBuilder][ctas][' + index + '][border_color]')
		.attr('id', form_id + 'ctas-' + index + '-border_color')
		.next('.sp-replacer').remove();
	}

	function _updateResizeIcon($resize_btn, mode)
	{
		var $first_icon  = $resize_btn.find('i').first();
		var $second_icon = $first_icon.next('i').first();

		$first_icon.removeClass('adzicon-arrow_left adzicon-arrow_right fa-arrow-left fa-arrow-right');
		$second_icon.removeClass('adzicon-arrow_left adzicon-arrow_right fa-arrow-left fa-arrow-right');

		if (mode === 'open') {
			$first_icon.addClass('adzicon-arrow_left fa-arrow-left');
			$second_icon.addClass('adzicon-arrow_right fa-arrow-right');

			return;
		}

		// set to "close" mode (arrows are pointing to each other)
		$first_icon.addClass('adzicon-arrow_right fa-arrow-right');
		$second_icon.addClass('adzicon-arrow_left fa-arrow-left');
	}

	function _replaceMediaHubFromPrototype($parent, prototype_selector, bind_key)
	{
		var $prototype_host  = $(prototype_selector);
		var $prototype       = null;
		var $existing        = $parent.find('.mh-btn-container, .mh-dragdrop-container').first();
		var template_content = null;
		var prototype_node   = null;

		if (!$prototype_host.length || !$existing.length) {
			return;
		}

		template_content = $prototype_host.prop('content');

		if (!template_content) {
			return;
		}

		prototype_node = template_content.querySelector('.mh-btn-container, .mh-dragdrop-container');

		if (!prototype_node) {
			return;
		}

		// importNode adopts the copy into this document; jQuery clone() throws on
		// template-owned nodes because their owner document has no documentElement
		$prototype = $(document.importNode(prototype_node, true));

		$prototype.attr('data-bind-key', bind_key);
		$prototype.removeAttr('id');
		$existing.replaceWith($prototype);
	}

	function _initMediaHubInContainer($container)
	{
		if (typeof Adzuki.MediaHubComponent !== 'undefined') {
			$container.find('.mh-btn-container').each(function initMediaHubComponent() {
				Adzuki.MediaHubComponent.init(this);
			});
		}

		if (typeof Adzuki.MediaHubDragDrop !== 'undefined') {
			$container.find('.mh-dragdrop-container').each(function initMediaHubDragDrop() {
				Adzuki.MediaHubDragDrop.init(this);
			});
		}
	}

	function _resetMediaHubDragDrop($container)
	{
		var $mediahub_dragdrop = $container.find('.mh-dragdrop-container').first();

		if (
			$mediahub_dragdrop.length
			&& typeof Adzuki.MediaHubDragDrop !== 'undefined'
		) {
			Adzuki.MediaHubDragDrop.reset($mediahub_dragdrop[0]);
		}
	}
}(jQuery, window.Adzuki || {}));
